/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.48.0-dev-20240420(8503aef01e4f06dff414c15904a1d961e25eb8eb)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/editor/editor.main.nls.de", {
	"vs/base/browser/ui/actionbar/actionViewItems": [
		"{0} ({1})",
	],
	"vs/base/browser/ui/findinput/findInput": [
		"Eingabe",
	],
	"vs/base/browser/ui/findinput/findInputToggles": [
		"Groß-/Kleinschreibung beachten",
		"Nur ganzes Wort suchen",
		"Regulären Ausdruck verwenden",
	],
	"vs/base/browser/ui/findinput/replaceInput": [
		"Eingabe",
		"Groß-/Kleinschreibung beibehalten",
	],
	"vs/base/browser/ui/hover/hoverWidget": [
		"Überprüfen Sie dies in der barrierefreien Ansicht mit \"{0}\".",
		"Überprüfen Sie dies in der barrierefreien Ansicht über den Befehl \"Barrierefreie Ansicht öffnen\", der zurzeit nicht über eine Tastenzuordnung ausgelöst werden kann.",
	],
	"vs/base/browser/ui/inputbox/inputBox": [
		"Fehler: {0}",
		"Warnung: {0}",
		"Info: {0}",
		" oder {0} für Verlauf",
		" ({0} für Verlauf)",
		"Gelöschte Eingabe",
	],
	"vs/base/browser/ui/keybindingLabel/keybindingLabel": [
		"Ungebunden",
	],
	"vs/base/browser/ui/selectBox/selectBoxCustom": [
		"Auswahlfeld",
	],
	"vs/base/browser/ui/toolbar/toolbar": [
		"Weitere Aktionen...",
	],
	"vs/base/browser/ui/tree/abstractTree": [
		"Filter",
		"Fuzzyübereinstimmung",
		"Zum Filtern Text eingeben",
		"Zum Suchen eingeben",
		"Zum Suchen eingeben",
		"Schließen",
		"Kein Element gefunden.",
	],
	"vs/base/common/actions": [
		"(leer)",
	],
	"vs/base/common/errorMessage": [
		"{0}: {1}",
		"Ein Systemfehler ist aufgetreten ({0}).",
		"Ein unbekannter Fehler ist aufgetreten. Weitere Details dazu finden Sie im Protokoll.",
		"Ein unbekannter Fehler ist aufgetreten. Weitere Details dazu finden Sie im Protokoll.",
		"{0} ({1} Fehler gesamt)",
		"Ein unbekannter Fehler ist aufgetreten. Weitere Details dazu finden Sie im Protokoll.",
	],
	"vs/base/common/keybindingLabels": [
		"STRG",
		"UMSCHALTTASTE",
		"ALT",
		"Windows",
		"STRG",
		"UMSCHALTTASTE",
		"ALT",
		"Super",
		"Steuern",
		"UMSCHALTTASTE",
		"Option",
		"Befehl",
		"Steuern",
		"UMSCHALTTASTE",
		"ALT",
		"Windows",
		"Steuern",
		"UMSCHALTTASTE",
		"ALT",
		"Super",
	],
	"vs/base/common/platform": [
		"_",
	],
	"vs/editor/browser/controller/textAreaHandler": [
		"Editor",
		"Auf den Editor kann zurzeit nicht zugegriffen werden.",
		"{0} Um den für die Sprachausgabe optimierten Modus zu aktivieren, verwenden Sie {1}",
		"{0} Um den für die Sprachausgabe optimierten Modus zu aktivieren, öffnen Sie die Schnellauswahl mit {1}, und führen Sie den Befehl \"Barrierefreiheitsmodus der Bildschirmsprachausgabe umschalten\" aus, der derzeit nicht über die Tastatur ausgelöst werden kann.",
		"{0} Weisen Sie eine Tastenzuordnung für den Befehl \"Barrierefreiheitsmodus der Sprachausgabe umschalten\" zu, indem Sie mit auf den Editor für Tastenzuordnungen zugreifen {1} und ihn ausführen.",
	],
	"vs/editor/browser/coreCommands": [
		"Auch bei längeren Zeilen am Ende bleiben",
		"Auch bei längeren Zeilen am Ende bleiben",
		"Sekundäre Cursor entfernt",
	],
	"vs/editor/browser/editorExtensions": [
		"&&Rückgängig",
		"Rückgängig",
		"&&Wiederholen",
		"Wiederholen",
		"&&Alles auswählen",
		"Alle auswählen",
	],
	"vs/editor/browser/services/hoverService/hoverWidget": [
		"Hold {0} key to mouse over",
	],
	"vs/editor/browser/services/hoverService/updatableHoverWidget": [
		"Loading...",
	],
	"vs/editor/browser/widget/codeEditor/codeEditorWidget": [
		"The number of cursors has been limited to {0}. Consider using [find and replace](https://code.visualstudio.com/docs/editor/codebasics#_find-and-replace) for larger changes or increase the editor multi cursor limit setting.",
		"Increase Multi Cursor Limit",
	],
	"vs/editor/browser/widget/diffEditor/commands": [
		"Toggle Collapse Unchanged Regions",
		"Toggle Show Moved Code Blocks",
		"Toggle Use Inline View When Space Is Limited",
		"Diff Editor",
		"Switch Side",
		"Exit Compare Move",
		"Collapse All Unchanged Regions",
		"Show All Unchanged Regions",
		"Revert",
		"Accessible Diff Viewer",
		"Go to Next Difference",
		"Go to Previous Difference",
	],
	"vs/editor/browser/widget/diffEditor/components/accessibleDiffViewer": [
		"Symbol für \"Einfügen\" im barrierefreien Diff-Viewer.",
		"Symbol für \"Entfernen\" im barrierefreien Diff-Viewer.",
		"Symbol für \"Schließen\" im barrierefreien Diff-Viewer.",
		"Schließen",
		"Barrierefreier Diff-Viewer. Verwenden Sie den Pfeil nach oben und unten, um zu navigieren.",
		"keine geänderten Zeilen",
		"1 Zeile geändert",
		"{0} Zeilen geändert",
		"Unterschied {0} von {1}: ursprüngliche Zeile {2}, {3}, geänderte Zeile {4}, {5}",
		"leer",
		"{0}: unveränderte Zeile {1}",
		"{0} ursprüngliche Zeile {1} geänderte Zeile {2}",
		"+ {0} geänderte Zeile(n) {1}",
		"– {0} Originalzeile {1}",
	],
	"vs/editor/browser/widget/diffEditor/components/diffEditorEditors": [
		" verwenden Sie {0}, um die Hilfe zur Barrierefreiheit zu öffnen.",
	],
	"vs/editor/browser/widget/diffEditor/components/diffEditorViewZones/inlineDiffDeletedCodeMargin": [
		"Gelöschte Zeilen kopieren",
		"Gelöschte Zeile kopieren",
		"Geänderte Zeilen kopieren",
		"Geänderte Zeile kopieren",
		"Gelöschte Zeile kopieren ({0})",
		"Geänderte Zeile ({0}) kopieren",
		"Diese Änderung rückgängig machen",
	],
	"vs/editor/browser/widget/diffEditor/diffEditor.contribution": [
		"Bei eingeschränktem Speicherplatz Inlineansicht verwenden",
		"Verschobene Codeblöcke anzeigen",
		"Revert Block",
		"Revert Selection",
		"Barrierefreien Diff-Viewer öffnen",
	],
	"vs/editor/browser/widget/diffEditor/features/hideUnchangedRegionsFeature": [
		"Unveränderten Bereich falten",
		"Klicken oder ziehen Sie, um oben mehr anzuzeigen.",
		"Unveränderte Regionen anzeigen",
		"Klicken oder ziehen Sie, um unten mehr anzuzeigen.",
		"{0} ausgeblendete Linien",
		"Zum Auffalten doppelklicken",
	],
	"vs/editor/browser/widget/diffEditor/features/movedBlocksLinesFeature": [
		"Code mit Änderungen in Zeile {0}-{1} verschoben",
		"Code mit Änderungen aus Zeile {0}-{1} verschoben",
		"Code in Zeile {0}-{1} verschoben",
		"Code aus Zeile {0}-{1} verschoben",
	],
	"vs/editor/browser/widget/diffEditor/features/revertButtonsFeature": [
		"Ausgewählte Änderungen zurücksetzen",
		"Änderung zurücksetzen",
	],
	"vs/editor/browser/widget/diffEditor/registrations.contribution": [
		"Die Rahmenfarbe für Text, der im Diff-Editor verschoben wurde.",
		"Die aktive Rahmenfarbe für Text, der im Diff-Editor verschoben wurde.",
		"Die Farbe des Schattens um unveränderte Regionswidgets.",
		"Zeilenformatierung für Einfügungen im Diff-Editor",
		"Zeilenformatierung für Entfernungen im Diff-Editor",
	],
	"vs/editor/browser/widget/multiDiffEditor/colors": [
		"The background color of the diff editor\'s header",
		"The background color of the multi file diff editor",
		"The border color of the multi file diff editor",
	],
	"vs/editor/common/config/editorConfigurationSchema": [
		"Editor",
		"Die Anzahl der Leerzeichen, denen ein Tabstopp entspricht. Diese Einstellung wird basierend auf dem Inhalt der Datei überschrieben, wenn {0} aktiviert ist.",
		"Die Anzahl von Leerzeichen, die für den Einzug oder „tabSize“ verwendet werden, um den Wert aus „#editor.tabSize#“ zu verwenden. Diese Einstellung wird basierend auf dem Dateiinhalt überschrieben, wenn „#editor.detectIndentation#“ aktiviert ist.",
		"Fügt beim Drücken der TAB-Taste Leerzeichen ein. Diese Einstellung wird basierend auf dem Inhalt der Datei überschrieben, wenn {0} aktiviert ist.",
		"Steuert, ob {0} und {1} automatisch erkannt werden, wenn eine Datei basierend auf dem Dateiinhalt geöffnet wird.",
		"Nachfolgende automatisch eingefügte Leerzeichen entfernen",
		"Spezielle Behandlung für große Dateien zum Deaktivieren bestimmter speicherintensiver Funktionen.",
		"Deaktivieren Sie Word-basierte Vorschläge.",
		"Nur Wörter aus dem aktiven Dokument vorschlagen",
		"Wörter aus allen geöffneten Dokumenten derselben Sprache vorschlagen",
		"Wörter aus allen geöffneten Dokumenten vorschlagen",
		"Steuert, ob Vervollständigungen auf Grundlage der Wörter im Dokument berechnet werden sollen, und aus welchen Dokumenten sie berechnet werden sollen.",
		"Die semantische Hervorhebung ist für alle Farbdesigns aktiviert.",
		"Die semantische Hervorhebung ist für alle Farbdesigns deaktiviert.",
		"Die semantische Hervorhebung wird durch die Einstellung \"semanticHighlighting\" des aktuellen Farbdesigns konfiguriert.",
		"Steuert, ob die semantische Hervorhebung für die Sprachen angezeigt wird, die sie unterstützen.",
		"Lassen Sie Peek-Editoren geöffnet, auch wenn Sie auf ihren Inhalt doppelklicken oder auf die ESCAPETASTE klicken.",
		"Zeilen, die diese Länge überschreiten, werden aus Leistungsgründen nicht tokenisiert",
		"Steuert, ob die Tokenisierung asynchron auf einem Webworker erfolgen soll.",
		"Steuert, ob die asynchrone Tokenisierung protokolliert werden soll. Nur zum Debuggen.",
		"Steuert, ob die asynchrone Tokenisierung anhand der Legacy-Hintergrundtokenisierung überprüft werden soll. Die Tokenisierung kann verlangsamt werden. Nur zum Debuggen.",
		"Definiert die Klammersymbole, die den Einzug vergrößern oder verkleinern.",
		"Das öffnende Klammerzeichen oder die Zeichenfolgensequenz.",
		"Das schließende Klammerzeichen oder die Zeichenfolgensequenz.",
		"Definiert die Klammerpaare, die durch ihre Schachtelungsebene farbig formatiert werden, wenn die Farbgebung für das Klammerpaar aktiviert ist.",
		"Das öffnende Klammerzeichen oder die Zeichenfolgensequenz.",
		"Das schließende Klammerzeichen oder die Zeichenfolgensequenz.",
		"Timeout in Millisekunden, nach dem die Diff-Berechnung abgebrochen wird. Bei 0 wird kein Timeout verwendet.",
		"Maximale Dateigröße in MB, für die Diffs berechnet werden sollen. Verwenden Sie 0, um keinen Grenzwert zu setzen.",
		"Steuert, ob der Diff-Editor die Unterschiede nebeneinander oder im Text anzeigt.",
		"Wenn die Breite des Diff-Editors unter diesem Wert liegt, wird die Inlineansicht verwendet.",
		"Wenn diese Option aktiviert ist und die Breite des Editors nicht ausreicht, wird die Inlineansicht verwendet.",
		"Wenn diese Option aktiviert ist, zeigt der Diff-Editor Pfeile in seinem Glyphenrand an, um Änderungen rückgängig zu machen.",
		"When enabled, the diff editor shows a special gutter for revert and stage actions.",
		"Wenn aktiviert, ignoriert der Diff-Editor Änderungen an voran- oder nachgestellten Leerzeichen.",
		"Steuert, ob der Diff-Editor die Indikatoren \"+\" und \"-\" für hinzugefügte/entfernte Änderungen anzeigt.",
		"Steuert, ob der Editor CodeLens anzeigt.",
		"Zeilenumbrüche erfolgen nie.",
		"Der Zeilenumbruch erfolgt an der Breite des Anzeigebereichs.",
		"Zeilen werden gemäß der Einstellung „{0}“ umbrochen.",
		"Verwendet den Legacyvergleichsalgorithmus.",
		"Verwendet den erweiterten Vergleichsalgorithmus.",
		"Steuert, ob der Diff-Editor unveränderte Regionen anzeigt.",
		"Steuert, wie viele Zeilen für unveränderte Regionen verwendet werden.",
		"Steuert, wie viele Zeilen als Mindestwert für unveränderte Regionen verwendet werden.",
		"Steuert, wie viele Zeilen beim Vergleich unveränderter Regionen als Kontext verwendet werden.",
		"Steuert, ob der Diff-Editor erkannte Codeverschiebevorgänge anzeigen soll.",
		"Steuert, ob der diff-Editor leere Dekorationen anzeigt, um anzuzeigen, wo Zeichen eingefügt oder gelöscht wurden.",
	],
	"vs/editor/common/config/editorOptions": [
		"Verwenden Sie Plattform-APIs, um zu erkennen, wenn eine Sprachausgabe angefügt ist.",
		"Optimieren Sie diese Option für die Verwendung mit einer Sprachausgabe.",
		"Hiermit wird angenommen, dass keine Sprachausgabe angefügt ist.",
		"Steuert, ob die Benutzeroberfläche in einem Modus ausgeführt werden soll, in dem sie für Sprachausgaben optimiert ist.",
		"Steuert, ob beim Kommentieren ein Leerzeichen eingefügt wird.",
		"Steuert, ob leere Zeilen bei Umschalt-, Hinzufügungs- oder Entfernungsaktionen für Zeilenkommentare ignoriert werden sollen.",
		"Steuert, ob ein Kopiervorgang ohne Auswahl die aktuelle Zeile kopiert.",
		"Steuert, ob der Cursor bei der Suche nach Übereinstimmungen während der Eingabe springt.",
		"Suchzeichenfolge niemals aus der Editorauswahl seeden.",
		"Suchzeichenfolge immer aus der Editorauswahl seeden, einschließlich Wort an Cursorposition.",
		"Suchzeichenfolge nur aus der Editorauswahl seeden.",
		"Steuert, ob für die Suchzeichenfolge im Widget \"Suche\" ein Seeding aus der Auswahl des Editors ausgeführt wird.",
		"\"In Auswahl suchen\" niemals automatisch aktivieren (Standard).",
		"\"In Auswahl suchen\" immer automatisch aktivieren.",
		"\"In Auswahl suchen\" automatisch aktivieren, wenn mehrere Inhaltszeilen ausgewählt sind.",
		"Steuert die Bedingung zum automatischen Aktivieren von \"In Auswahl suchen\".",
		"Steuert, ob das Widget \"Suche\" die freigegebene Suchzwischenablage unter macOS lesen oder bearbeiten soll.",
		"Steuert, ob das Suchwidget zusätzliche Zeilen im oberen Bereich des Editors hinzufügen soll. Wenn die Option auf \"true\" festgelegt ist, können Sie über die erste Zeile hinaus scrollen, wenn das Suchwidget angezeigt wird.",
		"Steuert, ob die Suche automatisch am Anfang (oder am Ende) neu gestartet wird, wenn keine weiteren Übereinstimmungen gefunden werden.",
		"Hiermit werden Schriftligaturen (Schriftartfeatures \"calt\" und \"liga\") aktiviert/deaktiviert. Ändern Sie diesen Wert in eine Zeichenfolge, um die CSS-Eigenschaft \"font-feature-settings\" detailliert zu steuern.",
		"Explizite CSS-Eigenschaft \"font-feature-settings\". Stattdessen kann ein boolescher Wert übergeben werden, wenn nur Ligaturen aktiviert/deaktiviert werden müssen.",
		"Hiermit werden Schriftligaturen oder Schriftartfeatures konfiguriert. Hierbei kann es sich entweder um einen booleschen Wert zum Aktivieren oder Deaktivieren von Ligaturen oder um eine Zeichenfolge für den Wert der CSS-Eigenschaft \"font-feature-settings\" handeln.",
		"Aktiviert/deaktiviert die Übersetzung von „font-weight“ in „font-variation-settings“. Ändern Sie dies in eine Zeichenfolge für eine differenzierte Steuerung der CSS-Eigenschaft „font-variation-settings“.",
		"Explizite CSS-Eigenschaft „font-variation-settings“. Stattdessen kann ein boolescher Wert eingeben werden, wenn nur „font-weight“ in „font-variation-settings“ übersetzt werden muss.",
		"Konfiguriert Variationen der Schriftart. Kann entweder ein boolescher Wert zum Aktivieren/Deaktivieren der Übersetzung von „font-weight“ in „font-variation-settings“ oder eine Zeichenfolge für den Wert der CSS-Eigenschaft „font-variation-settings“ sein.",
		"Legt die Schriftgröße in Pixeln fest.",
		"Es sind nur die Schlüsselwörter \"normal\" und \"bold\" sowie Zahlen zwischen 1 und 1000 zulässig.",
		"Steuert die Schriftbreite. Akzeptiert die Schlüsselwörter \"normal\" und \"bold\" sowie Zahlen zwischen 1 und 1000.",
		"Vorschauansicht der Ergebnisse anzeigen (Standardeinstellung)",
		"Zum Hauptergebnis gehen und Vorschauansicht anzeigen",
		"Wechseln Sie zum primären Ergebnis, und aktivieren Sie die Navigation ohne Vorschau zu anderen Ergebnissen.",
		"Diese Einstellung ist veraltet. Verwenden Sie stattdessen separate Einstellungen wie \"editor.editor.gotoLocation.multipleDefinitions\" oder \"editor.editor.gotoLocation.multipleImplementations\".",
		"Legt das Verhalten des Befehls \"Gehe zu Definition\" fest, wenn mehrere Zielpositionen vorhanden sind",
		"Legt das Verhalten des Befehls \"Gehe zur Typdefinition\" fest, wenn mehrere Zielpositionen vorhanden sind.",
		"Legt das Verhalten des Befehls \"Gehe zu Deklaration\" fest, wenn mehrere Zielpositionen vorhanden sind.",
		"Legt das Verhalten des Befehls \"Gehe zu Implementierungen\", wenn mehrere Zielspeicherorte vorhanden sind",
		"Legt das Verhalten des Befehls \"Gehe zu Verweisen\" fest, wenn mehrere Zielpositionen vorhanden sind",
		"Die alternative Befehls-ID, die ausgeführt wird, wenn das Ergebnis von \"Gehe zu Definition\" die aktuelle Position ist.",
		"Die alternative Befehls-ID, die ausgeführt wird, wenn das Ergebnis von \"Gehe zu Typdefinition\" die aktuelle Position ist.",
		"Die alternative Befehls-ID, die ausgeführt wird, wenn das Ergebnis von \"Gehe zu Deklaration\" der aktuelle Speicherort ist.",
		"Die alternative Befehls-ID, die ausgeführt wird, wenn das Ergebnis von \"Gehe zu Implementatierung\" der aktuelle Speicherort ist.",
		"Die alternative Befehls-ID, die ausgeführt wird, wenn das Ergebnis von \"Gehe zu Verweis\" die aktuelle Position ist.",
		"Steuert, ob die Hovermarkierung angezeigt wird.",
		"Steuert die Verzögerung in Millisekunden, nach der die Hovermarkierung angezeigt wird.",
		"Steuert, ob die Hovermarkierung sichtbar bleiben soll, wenn der Mauszeiger darüber bewegt wird.",
		"Steuert die Verzögerung in Millisekunden, nach der die Hovermarkierung ausgeblendet wird. Erfordert die Aktivierung von \"editor.hover.sticky\".",
		"Zeigen Sie den Mauszeiger lieber über der Linie an, wenn Platz vorhanden ist.",
		"Es wird angenommen, dass alle Zeichen gleich breit sind. Dies ist ein schneller Algorithmus, der für Festbreitenschriftarten und bestimmte Alphabete (wie dem lateinischen), bei denen die Glyphen gleich breit sind, korrekt funktioniert.",
		"Delegiert die Berechnung von Umbruchpunkten an den Browser. Dies ist ein langsamer Algorithmus, der bei großen Dateien Code Freezes verursachen kann, aber in allen Fällen korrekt funktioniert.",
		"Steuert den Algorithmus, der Umbruchpunkte berechnet. Beachten Sie, dass \"advanced\" im Barrierefreiheitsmodus für eine optimale Benutzererfahrung verwendet wird.",
		"Codeaktionsmenü deaktivieren.",
		"Zeigt das Codeaktionsmenü an, wenn sich der Cursor in Zeilen mit Code befindet.",
		"Zeigt das Codeaktionsmenü an, wenn sich der Cursor in Zeilen mit Code oder in leeren Zeilen befindet.",
		"Aktiviert das Glühlampensymbol für Codeaktionen im Editor.",
		"Zeigt die geschachtelten aktuellen Bereiche während des Bildlaufs am oberen Rand des Editors an.",
		"Definiert die maximale Anzahl fixierter Zeilen, die angezeigt werden sollen.",
		"Legt das Modell fest, das zur Bestimmung der zu fixierenden Zeilen verwendet wird. Existiert das Gliederungsmodell nicht, wird auf das Modell des Folding Providers zurückgegriffen, der wiederum auf das Einrückungsmodell zurückgreift. Diese Reihenfolge wird in allen drei Fällen beachtet.",
		"Hiermit aktivieren Sie das Scrollen mit fixiertem Bildlauf mit der horizontalen Scrollleiste des Editors.",
		"Aktiviert die Inlay-Hinweise im Editor.",
		"Inlay-Hinweise sind aktiviert",
		"Inlay-Hinweise werden standardmäßig angezeigt und ausgeblendet, wenn Sie {0} gedrückt halten",
		"Inlayhinweise sind standardmäßig ausgeblendet. Sie werden angezeigt, wenn {0} gedrückt gehalten wird.",
		"Inlay-Hinweise sind deaktiviert",
		"Steuert den Schriftgrad von Einlapphinweisen im Editor. Standardmäßig wird die {0} verwendet, wenn der konfigurierte Wert kleiner als {1} oder größer als der Schriftgrad des Editors ist.",
		"Steuert die Schriftartfamilie von Einlapphinweisen im Editor. Bei Festlegung auf \"leer\" wird die {0} verwendet.",
		"Aktiviert den Abstand um die Inlay-Hinweise im Editor.",
		"Steuert die Zeilenhöhe. \r\n – Verwenden Sie 0, um die Zeilenhöhe automatisch anhand des Schriftgrads zu berechnen.\r\n – Werte zwischen 0 und 8 werden als Multiplikator mit dem Schriftgrad verwendet.\r\n – Werte größer oder gleich 8 werden als effektive Werte verwendet.",
		"Steuert, ob die Minimap angezeigt wird.",
		"Steuert, ob die Minimap automatisch ausgeblendet wird.",
		"Die Minimap hat die gleiche Größe wie der Editor-Inhalt (und kann scrollen).",
		"Die Minimap wird bei Bedarf vergrößert oder verkleinert, um die Höhe des Editors zu füllen (kein Scrollen).",
		"Die Minimap wird bei Bedarf verkleinert, damit sie nicht größer als der Editor ist (kein Scrollen).",
		"Legt die Größe der Minimap fest.",
		"Steuert die Seite, wo die Minimap gerendert wird.",
		"Steuert, wann der Schieberegler für die Minimap angezeigt wird.",
		"Maßstab des in der Minimap gezeichneten Inhalts: 1, 2 oder 3.",
		"Die tatsächlichen Zeichen in einer Zeile rendern im Gegensatz zu Farbblöcken.",
		"Begrenzen Sie die Breite der Minimap, um nur eine bestimmte Anzahl von Spalten zu rendern.",
		"Controls whether named regions are shown as section headers in the minimap.",
		"Controls whether MARK: comments are shown as section headers in the minimap.",
		"Controls the font size of section headers in the minimap.",
		"Steuert den Abstand zwischen dem oberen Rand des Editors und der ersten Zeile.",
		"Steuert den Abstand zwischen dem unteren Rand des Editors und der letzten Zeile.",
		"Aktiviert ein Pop-up, das Dokumentation und Typ eines Parameters anzeigt während Sie tippen.",
		"Steuert, ob das Menü mit Parameterhinweisen zyklisch ist oder sich am Ende der Liste schließt.",
		"Schnelle Vorschläge werden im Vorschlagswidget angezeigt",
		"Schnelle Vorschläge werden als inaktiver Text angezeigt",
		"Schnelle Vorschläge sind deaktiviert",
		"Schnellvorschläge innerhalb von Zeichenfolgen aktivieren.",
		"Schnellvorschläge innerhalb von Kommentaren aktivieren.",
		"Schnellvorschläge außerhalb von Zeichenfolgen und Kommentaren aktivieren.",
		"Steuert, ob Vorschläge während des Tippens automatisch angezeigt werden sollen. Dies kann bei der Eingabe von Kommentaren, Zeichenketten und anderem Code kontrolliert werden. Schnellvorschläge können so konfiguriert werden, dass sie als Geistertext oder mit dem Vorschlags-Widget angezeigt werden. Beachten Sie auch die \'{0}\'-Einstellung, die steuert, ob Vorschläge durch Sonderzeichen ausgelöst werden.",
		"Zeilennummern werden nicht dargestellt.",
		"Zeilennummern werden als absolute Zahl dargestellt.",
		"Zeilennummern werden als Abstand in Zeilen an Cursorposition dargestellt.",
		"Zeilennummern werden alle 10 Zeilen dargestellt.",
		"Steuert die Anzeige von Zeilennummern.",
		"Anzahl der Zeichen aus Festbreitenschriftarten, ab der dieses Editor-Lineal gerendert wird.",
		"Farbe dieses Editor-Lineals.",
		"Vertikale Linien nach einer bestimmten Anzahl von Monospacezeichen rendern. Verwenden Sie mehrere Werte für mehrere Linien. Wenn das Array leer ist, werden keine Linien gerendert.",
		"Die vertikale Bildlaufleiste wird nur bei Bedarf angezeigt.",
		"Die vertikale Bildlaufleiste ist immer sichtbar.",
		"Die vertikale Bildlaufleiste wird immer ausgeblendet.",
		"Steuert die Sichtbarkeit der vertikalen Bildlaufleiste.",
		"Die horizontale Bildlaufleiste wird nur bei Bedarf angezeigt.",
		"Die horizontale Bildlaufleiste ist immer sichtbar.",
		"Die horizontale Bildlaufleiste wird immer ausgeblendet.",
		"Steuert die Sichtbarkeit der horizontalen Bildlaufleiste.",
		"Die Breite der vertikalen Bildlaufleiste.",
		"Die Höhe der horizontalen Bildlaufleiste.",
		"Steuert, ob Klicks nach Seite scrollen oder zur Klickposition springen.",
		"Wenn diese Option festgelegt ist, wird die Größe des Editorinhalts nicht durch die horizontale Scrollleiste vergrößert.",
		"Legt fest, ob alle nicht einfachen ASCII-Zeichen hervorgehoben werden. Nur Zeichen zwischen U+0020 und U+007E, Tabulator, Zeilenvorschub und Wagenrücklauf gelten als einfache ASCII-Zeichen.",
		"Legt fest, ob Zeichen, die nur als Platzhalter dienen oder überhaupt keine Breite haben, hervorgehoben werden.",
		"Legt fest, ob Zeichen hervorgehoben werden, die mit einfachen ASCII-Zeichen verwechselt werden können, mit Ausnahme derjenigen, die im aktuellen Gebietsschema des Benutzers üblich sind.",
		"Steuert, ob Zeichen in Kommentaren auch mit Unicode-Hervorhebung versehen werden sollen.",
		"Steuert, ob Zeichen in Zeichenfolgen auch mit Unicode-Hervorhebung versehen werden sollen.",
		"Definiert zulässige Zeichen, die nicht hervorgehoben werden.",
		"Unicodezeichen, die in zulässigen Gebietsschemas üblich sind, werden nicht hervorgehoben.",
		"Steuert, ob Inline-Vorschläge automatisch im Editor angezeigt werden.",
		"Die Symbolleiste „Inline-Vorschlag“ anzeigen, wenn ein Inline-Vorschlag angezeigt wird.",
		"Die Symbolleiste „Inline-Vorschlag“ anzeigen, wenn Sie mit dem Mauszeiger auf einen Inline-Vorschlag zeigen.",
		"Die Inlinevorschlagssymbolleiste nie anzeigen.",
		"Steuert, wann die Inlinevorschlagssymbolleiste angezeigt werden soll.",
		"Steuert, wie Inlinevorschläge mit dem Vorschlagswidget interagieren. Wenn diese Option aktiviert ist, wird das Vorschlagswidget nicht automatisch angezeigt, wenn Inlinevorschläge verfügbar sind.",
		"Steuert die Schriftfamilie der Inlinevorschläge.",
		"Steuert, ob Inlinebearbeitungen im Editor angezeigt werden.",
		"Die Symbolleiste für die Inlinebearbeitung anzeigen, wenn ein Inlinevorschlag angezeigt wird.",
		"Die Symbolleiste für die Inlinebearbeitung anzeigen, wenn Sie mit dem Mauszeiger auf einen Inlinevorschlag zeigen.",
		"Die Symbolleiste für die Inlinebearbeitung nie anzeigen.",
		"Steuert, wann die Symbolleiste für die Inlinebearbeitung angezeigt werden soll.",
		"Steuert die Schriftfamilie der Inlinebearbeitung.",
		"Steuert, ob der Hintergrund von Inlinebearbeitungen farbig dargestellt wird.",
		"Steuert, ob die Klammerpaar-Farbgebung aktiviert ist oder nicht. Verwenden Sie {0}, um die Hervorhebungsfarben der Klammer zu überschreiben.",
		"Steuert, ob jeder Klammertyp über einen eigenen unabhängigen Farbpool verfügt.",
		"Aktiviert Klammernpaarführungslinien.",
		"Aktiviert Klammernpaarführungslinien nur für das aktive Klammerpaar.",
		"Deaktiviert Klammernpaarführungslinien.",
		"Steuert, ob Führungslinien für Klammerpaare aktiviert sind oder nicht.",
		"Aktiviert horizontale Führungslinien als Ergänzung zu vertikalen Klammernpaarführungslinien.",
		"Aktiviert horizontale Führungslinien nur für das aktive Klammerpaar.",
		"Deaktiviert horizontale Führungslinien für Klammernpaare.",
		"Steuert, ob horizontale Führungslinien für Klammernpaare aktiviert sind oder nicht.",
		"Steuert, ob der Editor das aktive Klammerpaar hervorheben soll.",
		"Steuert, ob der Editor Einzugsführungslinien rendern soll.",
		"Hebt die aktive Einzugsführung hervor.",
		"Hebt die aktive Einzugshilfslinie hervor, selbst wenn Klammerhilfslinien hervorgehoben sind.",
		"Heben Sie die aktive Einzugshilfslinie nicht hervor.",
		"Steuert, ob der Editor die aktive Einzugsführungslinie hevorheben soll.",
		"Vorschlag einfügen, ohne den Text auf der rechten Seite des Cursors zu überschreiben",
		"Vorschlag einfügen und Text auf der rechten Seite des Cursors überschreiben",
		"Legt fest, ob Wörter beim Akzeptieren von Vervollständigungen überschrieben werden. Beachten Sie, dass dies von Erweiterungen abhängt, die für dieses Features aktiviert sind.",
		"Steuert, ob Filter- und Suchvorschläge geringfügige Tippfehler berücksichtigen.",
		"Steuert, ob bei der Sortierung Wörter priorisiert werden, die in der Nähe des Cursors stehen.",
		"Steuert, ob gespeicherte Vorschlagauswahlen in verschiedenen Arbeitsbereichen und Fenstern gemeinsam verwendet werden (dafür ist \"#editor.suggestSelection#\" erforderlich).",
		"Wählen Sie immer einen Vorschlag aus, wenn IntelliSense automatisch ausgelöst wird.",
		"Wählen Sie niemals einen Vorschlag aus, wenn IntelliSense automatisch ausgelöst wird.",
		"Wählen Sie einen Vorschlag nur aus, wenn IntelliSense aus einem Triggerzeichen ausgelöst wird.",
		"Wählen Sie einen Vorschlag nur aus, wenn Sie IntelliSense während der Eingabe auslösen.",
		"Steuert, ob ein Vorschlag ausgewählt wird, wenn das Widget angezeigt wird. Beachten Sie, dass dies nur für automatisch ausgelöste Vorschläge gilt (\"#editor.quickSuggestions#\" und \"#editor.suggestOnTriggerCharacters#\"), und dass ein Vorschlag immer ausgewählt wird, wenn er explizit aufgerufen wird, z. B. über STRG+LEERTASTE.",
		"Steuert, ob ein aktiver Schnipsel verhindert, dass der Bereich \"Schnelle Vorschläge\" angezeigt wird.",
		"Steuert, ob Symbole in Vorschlägen ein- oder ausgeblendet werden.",
		"Steuert die Sichtbarkeit der Statusleiste unten im Vorschlagswidget.",
		"Steuert, ob das Ergebnis des Vorschlags im Editor in der Vorschau angezeigt werden soll.",
		"Steuert, ob Vorschlagsdetails inline mit der Bezeichnung oder nur im Detailwidget angezeigt werden.",
		"Diese Einstellung ist veraltet. Die Größe des Vorschlagswidgets kann jetzt geändert werden.",
		"Diese Einstellung ist veraltet. Verwenden Sie stattdessen separate Einstellungen wie \"editor.suggest.showKeywords\" oder \"editor.suggest.showSnippets\".",
		"Wenn aktiviert, zeigt IntelliSense \"method\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"funktions\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"constructor\"-Vorschläge an.",
		"Wenn IntelliSense aktiviert ist, werden „veraltete“ Vorschläge angezeigt.",
		"Wenn dies aktiviert ist, erfordert die IntelliSense-Filterung, dass das erste Zeichen mit einem Wortanfang übereinstimmt, z. B. „c“ in „Console“ oder „WebContext“, aber _nicht_ bei „description“. Wenn diese Option deaktiviert ist, zeigt IntelliSense mehr Ergebnisse an, sortiert sie aber weiterhin nach der Übereinstimmungsqualität.",
		"Wenn aktiviert, zeigt IntelliSense \"field\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"variable\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"class\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"struct\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"interface\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"module\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"property\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"event\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"operator\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"unit\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"value\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"constant\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"enum\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"enumMember\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"keyword\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"text\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"color\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"file\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"reference\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"customcolor\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"folder\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"typeParameter\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense \"snippet\"-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense user-Vorschläge an.",
		"Wenn aktiviert, zeigt IntelliSense issues-Vorschläge an.",
		"Gibt an, ob führende und nachstehende Leerzeichen immer ausgewählt werden sollen.",
		"Gibt an, ob Unterwörter (z. B. \"foo\" in \"fooBar\" oder \"foo_bar\") ausgewählt werden sollen.",
		"Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.).",
		"Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.).",
		"Kein Einzug. Umbrochene Zeilen beginnen bei Spalte 1.",
		"Umbrochene Zeilen erhalten den gleichen Einzug wie das übergeordnete Element.",
		"Umbrochene Zeilen erhalten + 1 Einzug auf das übergeordnete Element.",
		"Umgebrochene Zeilen werden im Vergleich zum übergeordneten Element +2 eingerückt.",
		"Steuert die Einrückung der umbrochenen Zeilen.",
		"Steuert, ob Sie eine Datei per Drag & Drop in einen Text-Editor ziehen können, indem Sie die UMSCHALTTASTE gedrückt halten (anstatt die Datei in einem Editor zu öffnen).",
		"Steuert, ob beim Ablegen von Dateien im Editor ein Widget angezeigt wird. Mit diesem Widget können Sie steuern, wie die Datei ablegt wird.",
		"Zeigt das Widget für die Dropdownauswahl an, nachdem eine Datei im Editor abgelegt wurde.",
		"Das Widget für die Ablageauswahl wird nie angezeigt. Stattdessen wird immer der Standardablageanbieter verwendet.",
		"Steuert, ob Sie Inhalte auf unterschiedliche Weise einfügen können.",
		"Steuert, ob beim Einfügen von Inhalt im Editor ein Widget angezeigt wird. Mit diesem Widget können Sie steuern, wie die Datei eingefügt wird.",
		"Das Widget für die Einfügeauswahl anzeigen, nachdem der Inhalt in den Editor eingefügt wurde.",
		"Das Widget für die Einfügeauswahl wird nie angezeigt. Stattdessen wird immer das Standardeinfügeverhalten verwendet.",
		"Steuert, ob Vorschläge über Commitzeichen angenommen werden sollen. In JavaScript kann ein Semikolon (\";\") beispielsweise ein Commitzeichen sein, das einen Vorschlag annimmt und dieses Zeichen eingibt.",
		"Einen Vorschlag nur mit der EINGABETASTE akzeptieren, wenn dieser eine Änderung am Text vornimmt.",
		"Steuert, ob Vorschläge mit der EINGABETASTE (zusätzlich zur TAB-Taste) akzeptiert werden sollen. Vermeidet Mehrdeutigkeit zwischen dem Einfügen neuer Zeilen oder dem Annehmen von Vorschlägen.",
		"Steuert die Anzahl von Zeilen im Editor, die von einer Sprachausgabe in einem Arbeitsschritt gelesen werden können. Wenn eine Sprachausgabe erkannt wird, wird der Standardwert automatisch auf 500 festgelegt. Warnung: Ein Wert höher als der Standardwert, kann sich auf die Leistung auswirken.",
		"Editor-Inhalt",
		"Steuern Sie, ob Inlinevorschläge von einer Sprachausgabe angekündigt werden.",
		"Verwenden Sie Sprachkonfigurationen, um zu bestimmen, wann Klammern automatisch geschlossen werden sollen.",
		"Schließe Klammern nur automatisch, wenn der Cursor sich links von einem Leerzeichen befindet.",
		"Steuert, ob der Editor automatisch Klammern schließen soll, nachdem der Benutzer eine öffnende Klammer hinzugefügt hat.",
		"Verwenden Sie Sprachkonfigurationen, um festzulegen, wann Kommentare automatisch geschlossen werden sollen.",
		"Kommentare werden nur dann automatisch geschlossen, wenn sich der Cursor links von einem Leerraum befindet.",
		"Steuert, ob der Editor Kommentare automatisch schließen soll, nachdem die Benutzer*innen einen ersten Kommentar hinzugefügt haben.",
		"Angrenzende schließende Anführungszeichen oder Klammern werden nur überschrieben, wenn sie automatisch eingefügt wurden.",
		"Steuert, ob der Editor angrenzende schließende Anführungszeichen oder Klammern beim Löschen entfernen soll.",
		"Schließende Anführungszeichen oder Klammern werden nur überschrieben, wenn sie automatisch eingefügt wurden.",
		"Steuert, ob der Editor schließende Anführungszeichen oder Klammern überschreiben soll.",
		"Verwende die Sprachkonfiguration, um zu ermitteln, wann Anführungsstriche automatisch geschlossen werden.",
		"Schließende Anführungszeichen nur dann automatisch ergänzen, wenn der Cursor sich links von einem Leerzeichen befindet.",
		"Steuert, ob der Editor Anführungszeichen automatisch schließen soll, nachdem der Benutzer ein öffnendes Anführungszeichen hinzugefügt hat.",
		"Der Editor fügt den Einzug nicht automatisch ein.",
		"Der Editor behält den Einzug der aktuellen Zeile bei.",
		"Der Editor behält den in der aktuellen Zeile definierten Einzug bei und beachtet für Sprachen definierte Klammern.",
		"Der Editor behält den Einzug der aktuellen Zeile bei, beachtet von Sprachen definierte Klammern und ruft spezielle onEnterRules-Regeln auf, die von Sprachen definiert wurden.",
		"Der Editor behält den Einzug der aktuellen Zeile bei, beachtet die von Sprachen definierten Klammern, ruft von Sprachen definierte spezielle onEnterRules-Regeln auf und beachtet von Sprachen definierte indentationRules-Regeln.",
		"Legt fest, ob der Editor den Einzug automatisch anpassen soll, wenn Benutzer Zeilen eingeben, einfügen, verschieben oder einrücken",
		"Sprachkonfigurationen verwenden, um zu bestimmen, wann eine Auswahl automatisch umschlossen werden soll.",
		"Mit Anführungszeichen, nicht mit Klammern umschließen.",
		"Mit Klammern, nicht mit Anführungszeichen umschließen.",
		"Steuert, ob der Editor die Auswahl beim Eingeben von Anführungszeichen oder Klammern automatisch umschließt.",
		"Emuliert das Auswahlverhalten von Tabstoppzeichen, wenn Leerzeichen für den Einzug verwendet werden. Die Auswahl wird an Tabstopps ausgerichtet.",
		"Steuert, ob der Editor CodeLens anzeigt.",
		"Steuert die Schriftfamilie für CodeLens.",
		"Steuert den Schriftgrad in Pixeln für CodeLens. Bei Festlegung auf „0, 90 % von „#editor.fontSize#“ verwendet.",
		"Steuert, ob der Editor die Inline-Farbdecorators und die Farbauswahl rendern soll.",
		"Farbauswahl sowohl beim Klicken als auch beim Daraufzeigen des Farbdekorators anzeigen",
		"Farbauswahl beim Draufzeigen auf den Farbdekorator anzeigen",
		"Farbauswahl beim Klicken auf den Farbdekorator anzeigen",
		"Steuert die Bedingung, damit eine Farbauswahl aus einem Farbdekorator angezeigt wird.",
		"Steuert die maximale Anzahl von Farb-Decorators, die in einem Editor gleichzeitig gerendert werden können.",
		"Zulassen, dass die Auswahl per Maus und Tasten die Spaltenauswahl durchführt.",
		"Steuert, ob Syntax-Highlighting in die Zwischenablage kopiert wird.",
		"Steuert den Cursoranimationsstil.",
		"Die Smooth Caret-Animation ist deaktiviert.",
		"Die Smooth Caret-Animation ist nur aktiviert, wenn der Benutzer den Cursor mit einer expliziten Geste bewegt.",
		"Die Smooth Caret-Animation ist immer aktiviert.",
		"Steuert, ob die weiche Cursoranimation aktiviert werden soll.",
		"Steuert den Cursor-Stil.",
		"Steuert die Mindestanzahl sichtbarer führender Zeilen (mindestens 0) und nachfolgender Zeilen (mindestens 1) um den Cursor. Dies wird in einigen anderen Editoren als „scrollOff“ oder „scrollOffset“ bezeichnet.",
		"\"cursorSurroundingLines\" wird nur erzwungen, wenn die Auslösung über die Tastatur oder API erfolgt.",
		"\"cursorSurroundingLines\" wird immer erzwungen.",
		"Controls when `#editor.cursorSurroundingLines#` should be enforced.",
		"Steuert die Breite des Cursors, wenn `#editor.cursorStyle#` auf `line` festgelegt ist.",
		"Steuert, ob der Editor das Verschieben einer Auswahl per Drag and Drop zulässt.",
		"Verwenden Sie eine neue Rendering-Methode mit SVGs.",
		"Verwenden Sie eine neue Rendering-Methode mit Schriftartzeichen.",
		"Verwenden Sie die stabile Rendering-Methode.",
		"Steuert, ob Leerzeichen mit einer neuen experimentellen Methode gerendert werden.",
		"Multiplikator für Scrollgeschwindigkeit bei Drücken von ALT.",
		"Steuert, ob Codefaltung im Editor aktiviert ist.",
		"Verwenden Sie eine sprachspezifische Faltstrategie, falls verfügbar. Andernfalls wird eine einzugsbasierte verwendet.",
		"Einzugsbasierte Faltstrategie verwenden.",
		"Steuert die Strategie für die Berechnung von Faltbereichen.",
		"Steuert, ob der Editor eingefaltete Bereiche hervorheben soll.",
		"Steuert, ob der Editor Importbereiche automatisch reduziert.",
		"Die maximale Anzahl von faltbaren Regionen. Eine Erhöhung dieses Werts kann dazu führen, dass der Editor weniger reaktionsfähig wird, wenn die aktuelle Quelle eine große Anzahl von faltbaren Regionen aufweist.",
		"Steuert, ob eine Zeile aufgefaltet wird, wenn nach einer gefalteten Zeile auf den leeren Inhalt geklickt wird.",
		"Steuert die Schriftfamilie.",
		"Steuert, ob der Editor den eingefügten Inhalt automatisch formatieren soll. Es muss ein Formatierer vorhanden sein, der in der Lage ist, auch Dokumentbereiche zu formatieren.",
		"Steuert, ob der Editor die Zeile nach der Eingabe automatisch formatieren soll.",
		"Steuert, ob der Editor den vertikalen Glyphenrand rendert. Der Glyphenrand wird hauptsächlich zum Debuggen verwendet.",
		"Steuert, ob der Cursor im Übersichtslineal ausgeblendet werden soll.",
		"Legt den Abstand der Buchstaben in Pixeln fest.",
		"Steuert, ob die verknüpfte Bearbeitung im Editor aktiviert ist. Abhängig von der Sprache werden zugehörige Symbole, z. B. HTML-Tags, während der Bearbeitung aktualisiert.",
		"Steuert, ob der Editor Links erkennen und anklickbar machen soll.",
		"Passende Klammern hervorheben",
		"Ein Multiplikator, der für die Mausrad-Bildlaufereignisse \"deltaX\" und \"deltaY\" verwendet werden soll.",
		"Schriftart des Editors vergrößern, wenn das Mausrad verwendet und „Cmd“ gedrückt wird.",
		"Schriftart des Editors vergrößern, wenn das Mausrad verwendet und die STRG-TASTE gedrückt wird.",
		"Mehrere Cursor zusammenführen, wenn sie sich überlappen.",
		"Ist unter Windows und Linux der STRG-Taste und unter macOS der Befehlstaste zugeordnet.",
		"Ist unter Windows und Linux der ALT-Taste und unter macOS der Wahltaste zugeordnet.",
		"Der Modifizierer, der zum Hinzufügen mehrerer Cursor mit der Maus verwendet werden soll. Die Mausgesten \"Gehe zu Definition\" und \"Link öffnen\" werden so angepasst, dass sie nicht mit dem [Multicursormodifizierer](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-Modifizierer) in Konflikt stehen.",
		"Jeder Cursor fügt eine Textzeile ein.",
		"Jeder Cursor fügt den vollständigen Text ein.",
		"Steuert das Einfügen, wenn die Zeilenanzahl des Einfügetexts der Cursor-Anzahl entspricht.",
		"Steuert die maximale Anzahl von Cursorn, die sich gleichzeitig in einem aktiven Editor befindet.",
		"Hebt keine Vorkommen hervor.",
		"Hebt Vorkommen nur in der aktuellen Datei hervor.",
		"Experimentell: Hebt Vorkommen in allen gültigen geöffneten Dateien hervor.",
		"Steuert, ob Vorkommen in geöffneten Dateien hervorgehoben werden sollen.",
		"Steuert, ob um das Übersichtslineal ein Rahmen gezeichnet werden soll.",
		"Struktur beim Öffnen des Peek-Editors fokussieren",
		"Editor fokussieren, wenn Sie den Peek-Editor öffnen",
		"Steuert, ob der Inline-Editor oder die Struktur im Peek-Widget fokussiert werden soll.",
		"Steuert, ob die Mausgeste \"Gehe zu Definition\" immer das Vorschauwidget öffnet.",
		"Steuert die Verzögerung in Millisekunden nach der Schnellvorschläge angezeigt werden.",
		"Steuert, ob der Editor bei Eingabe automatisch eine Umbenennung vornimmt.",
		"Veraltet. Verwenden Sie stattdessen \"editor.linkedEditing\".",
		"Steuert, ob der Editor Steuerzeichen rendern soll.",
		"Letzte Zeilennummer rendern, wenn die Datei mit einem Zeilenumbruch endet.",
		"Hebt den Bundsteg und die aktuelle Zeile hervor.",
		"Steuert, wie der Editor die aktuelle Zeilenhervorhebung rendern soll.",
		"Steuert, ob der Editor die aktuelle Zeilenhervorhebung nur dann rendern soll, wenn der Fokus auf dem Editor liegt.",
		"Leerraumzeichen werden gerendert mit Ausnahme der einzelnen Leerzeichen zwischen Wörtern.",
		"Hiermit werden Leerraumzeichen nur für ausgewählten Text gerendert.",
		"Nur nachstehende Leerzeichen rendern",
		"Steuert, wie der Editor Leerzeichen rendern soll.",
		"Steuert, ob eine Auswahl abgerundete Ecken aufweisen soll.",
		"Steuert die Anzahl der zusätzlichen Zeichen, nach denen der Editor horizontal scrollt.",
		"Steuert, ob der Editor jenseits der letzten Zeile scrollen wird.",
		"Nur entlang der vorherrschenden Achse scrollen, wenn gleichzeitig vertikal und horizontal gescrollt wird. Dadurch wird ein horizontaler Versatz beim vertikalen Scrollen auf einem Trackpad verhindert.",
		"Steuert, ob die primäre Linux-Zwischenablage unterstützt werden soll.",
		"Steuert, ob der Editor Übereinstimmungen hervorheben soll, die der Auswahl ähneln.",
		"Steuerelemente für die Codefaltung immer anzeigen.",
		"Zeigen Sie niemals die Faltungssteuerelemente an, und verringern Sie die Größe des Bundstegs.",
		"Steuerelemente für die Codefaltung nur anzeigen, wenn sich die Maus über dem Bundsteg befindet.",
		"Steuert, wann die Steuerungselemente für die Codefaltung am Bundsteg angezeigt werden.",
		"Steuert das Ausblenden von nicht verwendetem Code.",
		"Steuert durchgestrichene veraltete Variablen.",
		"Zeige Schnipselvorschläge über den anderen Vorschlägen.",
		"Schnipselvorschläge unter anderen Vorschlägen anzeigen.",
		"Zeige Schnipselvorschläge mit anderen Vorschlägen.",
		"Keine Schnipselvorschläge anzeigen.",
		"Steuert, ob Codeschnipsel mit anderen Vorschlägen angezeigt und wie diese sortiert werden.",
		"Legt fest, ob der Editor Bildläufe animiert ausführt.",
		"Steuert, ob für Benutzer*innen, die eine Sprachausgabe nutzen, bei Anzeige einer Inlinevervollständigung ein Hinweis zur Barrierefreiheit angezeigt werden soll.",
		"Schriftgrad für das Vorschlagswidget. Bei Festlegung auf {0} wird der Wert von {1} verwendet.",
		"Zeilenhöhe für das Vorschlagswidget. Bei Festlegung auf {0} wird der Wert von {1} verwendet. Der Mindestwert ist 8.",
		"Steuert, ob Vorschläge automatisch angezeigt werden sollen, wenn Triggerzeichen eingegeben werden.",
		"Immer den ersten Vorschlag auswählen.",
		"Wählen Sie die aktuellsten Vorschläge aus, es sei denn, es wird ein Vorschlag durch eine weitere Eingabe ausgewählt, z.B. \"console.| -> console.log\", weil \"log\" vor Kurzem abgeschlossen wurde.",
		"Wählen Sie Vorschläge basierend auf früheren Präfixen aus, die diese Vorschläge abgeschlossen haben, z.B. \"co -> console\" und \"con ->\" const\".",
		"Steuert, wie Vorschläge bei Anzeige der Vorschlagsliste vorab ausgewählt werden.",
		"Die Tab-Vervollständigung fügt den passendsten Vorschlag ein, wenn auf Tab gedrückt wird.",
		"Tab-Vervollständigungen deaktivieren.",
		"Codeschnipsel per Tab vervollständigen, wenn die Präfixe übereinstimmen. Funktioniert am besten, wenn \"quickSuggestions\" deaktiviert sind.",
		"Tab-Vervollständigungen aktivieren.",
		"Ungewöhnliche Zeilenabschlusszeichen werden automatisch entfernt.",
		"Ungewöhnliche Zeilenabschlusszeichen werden ignoriert.",
		"Zum Entfernen ungewöhnlicher Zeilenabschlusszeichen wird eine Eingabeaufforderung angezeigt.",
		"Entfernen Sie unübliche Zeilenabschlusszeichen, die Probleme verursachen können.",
		"Spaces and tabs are inserted and deleted in alignment with tab stops.",
		"Verwenden Sie die Standardregel für Zeilenumbrüche.",
		"Trennstellen dürfen nicht für Texte in Chinesisch/Japanisch/Koreanisch (CJK) verwendet werden. Das Verhalten von Nicht-CJK-Texten ist mit dem für normales Verhalten identisch.",
		"Steuert die Regeln für Trennstellen, die für Texte in Chinesisch/Japanisch/Koreanisch (CJK) verwendet werden.",
		"Zeichen, die als Worttrennzeichen verwendet werden, wenn wortbezogene Navigationen oder Vorgänge ausgeführt werden.",
		"Zeilenumbrüche erfolgen nie.",
		"Der Zeilenumbruch erfolgt an der Breite des Anzeigebereichs.",
		"Der Zeilenumbruch erfolgt bei \"#editor.wordWrapColumn#\".",
		"Der Zeilenumbruch erfolgt beim Mindestanzeigebereich und \"#editor.wordWrapColumn\".",
		"Steuert, wie der Zeilenumbruch durchgeführt werden soll.",
		"Steuert die umschließende Spalte des Editors, wenn \"#editor.wordWrap#\" den Wert \"wordWrapColumn\" oder \"bounded\" aufweist.",
		"Steuert, ob Inlinefarbdekorationen mithilfe des Standard-Dokumentfarbanbieters angezeigt werden sollen.",
		"Steuert, ob der Editor Registerkarten empfängt oder zur Navigation zur Workbench zurückgibt.",
	],
	"vs/editor/common/core/editorColorRegistry": [
		"Hintergrundfarbe zur Hervorhebung der Zeile an der Cursorposition.",
		"Hintergrundfarbe für den Rahmen um die Zeile an der Cursorposition.",
		"Hintergrundfarbe der markierten Bereiche, wie z.B. Quick Open oder die Suche. Die Farbe darf nicht deckend sein, weil sie sonst die zugrunde liegenden Dekorationen verdeckt.",
		"Hintergrundfarbe für den Rahmen um hervorgehobene Bereiche.",
		"Hintergrundfarbe des hervorgehobenen Symbols, z. B. \"Gehe zu Definition\" oder \"Gehe zu nächster/vorheriger\". Die Farbe darf nicht undurchsichtig sein, um zugrunde liegende Dekorationen nicht zu verbergen.",
		"Hintergrundfarbe des Rahmens um hervorgehobene Symbole",
		"Farbe des Cursors im Editor.",
		"Hintergrundfarbe vom Editor-Cursor. Erlaubt die Anpassung der Farbe von einem Zeichen, welches von einem Block-Cursor überdeckt wird.",
		"Color of the primary editor cursor when multiple cursors are present.",
		"The background color of the primary editor cursor when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.",
		"Color of secondary editor cursors when multiple cursors are present.",
		"The background color of secondary editor cursors when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.",
		"Farbe der Leerzeichen im Editor.",
		"Zeilennummernfarbe im Editor.",
		"Farbe der Führungslinien für Einzüge im Editor.",
		"\"editorIndentGuide.background\" ist veraltet. Verwenden Sie stattdessen \"editorIndentGuide.background1\".",
		"Farbe der Führungslinien für Einzüge im aktiven Editor.",
		"\"editorIndentGuide.activeBackground\" ist veraltet. Verwenden Sie stattdessen \"editorIndentGuide.activeBackground1\".",
		"Farbe der Führungslinien für Einzüge im Editor (1).",
		"Farbe der Führungslinien für Einzüge im Editor (2).",
		"Farbe der Führungslinien für Einzüge im Editor (3).",
		"Farbe der Führungslinien für Einzüge im Editor (4).",
		"Farbe der Führungslinien für Einzüge im Editor (5).",
		"Farbe der Führungslinien für Einzüge im Editor (6).",
		"Farbe der Führungslinien für Einzüge im aktiven Editor (1).",
		"Farbe der Führungslinien für Einzüge im aktiven Editor (2).",
		"Farbe der Führungslinien für Einzüge im aktiven Editor (3).",
		"Farbe der Führungslinien für Einzüge im aktiven Editor (4).",
		"Farbe der Führungslinien für Einzüge im aktiven Editor (5).",
		"Farbe der Führungslinien für Einzüge im aktiven Editor (6).",
		"Zeilennummernfarbe der aktiven Editorzeile.",
		"Die ID ist veraltet. Verwenden Sie stattdessen \"editorLineNumber.activeForeground\".",
		"Zeilennummernfarbe der aktiven Editorzeile.",
		"Die Farbe der letzten Editor-Zeile, wenn „editor.renderFinalNewline“ auf „abgeblendet“ festgelegt ist.",
		"Farbe des Editor-Lineals.",
		"Vordergrundfarbe der CodeLens-Links im Editor",
		"Hintergrundfarbe für zusammengehörige Klammern",
		"Farbe für zusammengehörige Klammern",
		"Farbe des Rahmens für das Übersicht-Lineal.",
		"Hintergrundfarbe des Editor-Übersichtslineals.",
		"Hintergrundfarbe der Editorleiste. Die Leiste enthält die Glyphenränder und die Zeilennummern.",
		"Rahmenfarbe unnötigen (nicht genutzten) Quellcodes im Editor.",
		"Deckkraft des unnötigen (nicht genutzten) Quellcodes im Editor. \"#000000c0\" rendert z.B. den Code mit einer Deckkraft von 75%. Verwenden Sie für Designs mit hohem Kontrast das Farbdesign \"editorUnnecessaryCode.border\", um unnötigen Code zu unterstreichen statt ihn abzublenden.",
		"Rahmenfarbe des Ghost-Texts im Editor.",
		"Vordergrundfarbe des Ghost-Texts im Editor.",
		"Hintergrundfarbe des Ghost-Texts im Editor.",
		"Übersichtslinealmarkerfarbe für das Hervorheben von Bereichen. Die Farbe darf nicht deckend sein, weil sie sonst die zugrunde liegenden Dekorationen verdeckt.",
		"Übersichtslineal-Markierungsfarbe für Fehler.",
		"Übersichtslineal-Markierungsfarbe für Warnungen.",
		"Übersichtslineal-Markierungsfarbe für Informationen.",
		"Vordergrundfarbe der Klammern (1). Erfordert die Aktivierung der Farbgebung des Klammerpaars.",
		"Vordergrundfarbe der Klammern (2). Erfordert die Aktivierung der Farbgebung des Klammerpaars.",
		"Vordergrundfarbe der Klammern (3). Erfordert die Aktivierung der Farbgebung des Klammerpaars.",
		"Vordergrundfarbe der Klammern (4). Erfordert die Aktivierung der Farbgebung des Klammerpaars.",
		"Vordergrundfarbe der Klammern (5). Erfordert die Aktivierung der Farbgebung des Klammerpaars.",
		"Vordergrundfarbe der Klammern (6). Erfordert die Aktivierung der Farbgebung des Klammerpaars.",
		"Vordergrundfarbe der unerwarteten Klammern.",
		"Hintergrundfarbe der inaktiven Klammerpaar-Hilfslinien (1). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der inaktiven Klammerpaar-Hilfslinien (2). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der inaktiven Klammerpaar-Hilfslinien (3). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der inaktiven Klammerpaar-Hilfslinien (4). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der inaktiven Klammerpaar-Hilfslinien (5). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der inaktiven Klammerpaar-Hilfslinien (6). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der aktiven Klammerpaar-Hilfslinien (1). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der aktiven Klammerpaar-Hilfslinien (2). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der aktiven Klammerpaar-Hilfslinien (3). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der aktiven Klammerpaar-Hilfslinien (4). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der aktiven Klammerpaar-Hilfslinien (5). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Hintergrundfarbe der aktiven Klammerpaar-Hilfslinien (6). Erfordert das Aktivieren von Klammerpaar-Hilfslinien.",
		"Rahmenfarbe, die zum Hervorheben von Unicode-Zeichen verwendet wird.",
		"Hintergrundfarbe, die zum Hervorheben von Unicode-Zeichen verwendet wird.",
	],
	"vs/editor/common/editorContextKeys": [
		"Gibt an, ob der Editor-Text den Fokus besitzt (Cursor blinkt).",
		"Gibt an, ob der Editor oder ein Editor-Widget den Fokus besitzt (z. B. ob der Fokus sich im Suchwidget befindet).",
		"Gibt an, ob ein Editor oder eine Rich-Text-Eingabe den Fokus besitzt (Cursor blinkt).",
		"Gibt an, ob der Editor schreibgeschützt ist",
		"Gibt an, ob der Kontext ein Diff-Editor ist.",
		"Gibt an, ob der Kontext ein eingebetteter Diff-Editor ist.",
		"Gibt an, ob der Kontext ein Multi-Diff-Editor ist.",
		"Gibt an, ob alle Dateien im Multi-Diff-Editor reduziert sind",
		"Gibt an, ob der Diff-Editor Änderungen aufweist.",
		"Gibt an, ob ein verschobener Codeblock für den Vergleich ausgewählt wird.",
		"Gibt an, ob der barrierefreie Diff-Viewer sichtbar ist.",
		"Gibt an, ob für den Diff-Editor der Breakpoint für das Rendern im Modus \"Parallel\" oder \"Inline\" erreicht wurde.",
		"Whether inline mode is active",
		"Whether modified is writable in the diff editor",
		"Whether modified is writable in the diff editor",
		"The uri of the original document",
		"The uri of the modified document",
		"Gibt an, ob \"editor.columnSelection\" aktiviert ist.",
		"Gibt an, ob im Editor Text ausgewählt ist.",
		"Gibt an, ob der Editor über Mehrfachauswahl verfügt.",
		"Gibt an, ob die TAB-TASTE den Fokus aus dem Editor verschiebt.",
		"Gibt an, ob Hover im Editor sichtbar ist.",
		"Gibt an, ob Daraufzeigen im Editor fokussiert ist.",
		"Gibt an, ob der Fokus auf dem Fixierten Bildlauf liegt.",
		"Gibt an, ob der Fixierte Bildlauf sichtbar ist.",
		"Gibt an, ob der eigenständige Farbwähler sichtbar ist.",
		"Gibt an, ob der eigenständige Farbwähler fokussiert ist.",
		"Gibt an, ob der Editor Bestandteil eines größeren Editors ist (z. B. Notebooks).",
		"Der Sprachbezeichner des Editors.",
		"Gibt an, ob der Editor über einen Vervollständigungselementanbieter verfügt.",
		"Gibt an, ob der Editor über einen Codeaktionsanbieter verfügt.",
		"Gibt an, ob der Editor über einen CodeLens-Anbieter verfügt.",
		"Gibt an, ob der Editor über einen Definitionsanbieter verfügt.",
		"Gibt an, ob der Editor über einen Deklarationsanbieter verfügt.",
		"Gibt an, ob der Editor über einen Implementierungsanbieter verfügt.",
		"Gibt an, ob der Editor über einen Typdefinitionsanbieter verfügt.",
		"Gibt an, ob der Editor über einen Hoveranbieter verfügt.",
		"Gibt an, ob der Editor über einen Dokumenthervorhebungsanbieter verfügt.",
		"Gibt an, ob der Editor über einen Dokumentsymbolanbieter verfügt.",
		"Gibt an, ob der Editor über einen Verweisanbieter verfügt.",
		"Gibt an, ob der Editor über einen Umbenennungsanbieter verfügt.",
		"Gibt an, ob der Editor über einen Signaturhilfeanbieter verfügt.",
		"Gibt an, ob der Editor über einen Inlinehinweisanbieter verfügt.",
		"Gibt an, ob der Editor über einen Dokumentformatierungsanbieter verfügt.",
		"Gibt an, ob der Editor über einen Anbieter für Dokumentauswahlformatierung verfügt.",
		"Gibt an, ob der Editor über mehrere Dokumentformatierungsanbieter verfügt.",
		"Gibt an, ob der Editor über mehrere Anbieter für Dokumentauswahlformatierung verfügt.",
	],
	"vs/editor/common/languages": [
		"Array",
		"Boolescher Wert",
		"Klasse",
		"Konstante",
		"Konstruktor",
		"Enumeration",
		"Enumerationsmember",
		"Ereignis",
		"Feld",
		"Datei",
		"Funktion",
		"Schnittstelle",
		"Schlüssel",
		"Methode",
		"Modul",
		"Namespace",
		"NULL",
		"Zahl",
		"Objekt",
		"Operator",
		"Paket",
		"Eigenschaft",
		"Zeichenfolge",
		"Struktur",
		"Typparameter",
		"Variable",
		"{0} ({1})",
	],
	"vs/editor/common/languages/modesRegistry": [
		"Nur-Text",
	],
	"vs/editor/common/model/editStack": [
		"Eingabe",
	],
	"vs/editor/common/standaloneStrings": [
		"Entwickler: Token überprüfen",
		"Gehe zu Zeile/Spalte...",
		"Alle Anbieter für den Schnellzugriff anzeigen",
		"Befehlspalette",
		"Befehle anzeigen und ausführen",
		"Gehe zu Symbol...",
		"Gehe zu Symbol nach Kategorie...",
		"Editor-Inhalt",
		"Drücken Sie ALT + F1, um die Barrierefreiheitsoptionen aufzurufen.",
		"Zu Design mit hohem Kontrast umschalten",
		"{0} Bearbeitungen in {1} Dateien durchgeführt",
	],
	"vs/editor/common/viewLayout/viewLineRenderer": [
		"Mehr anzeigen ({0})",
		"{0} Zeichen",
	],
	"vs/editor/contrib/anchorSelect/browser/anchorSelect": [
		"Auswahlanker",
		"Anker festgelegt bei \"{0}:{1}\"",
		"Auswahlanker festlegen",
		"Zu Auswahlanker wechseln",
		"Auswahl von Anker zu Cursor",
		"Auswahlanker abbrechen",
	],
	"vs/editor/contrib/bracketMatching/browser/bracketMatching": [
		"Übersichtslineal-Markierungsfarbe für zusammengehörige Klammern.",
		"Gehe zu Klammer",
		"Auswählen bis Klammer",
		"Klammern entfernen",
		"Gehe zu &&Klammer",
		"Text auswählen und Klammern oder geschweifte Klammern einschließen",
	],
	"vs/editor/contrib/caretOperations/browser/caretOperations": [
		"Ausgewählten Text nach links verschieben",
		"Ausgewählten Text nach rechts verschieben",
	],
	"vs/editor/contrib/caretOperations/browser/transpose": [
		"Buchstaben austauschen",
	],
	"vs/editor/contrib/clipboard/browser/clipboard": [
		"&&Ausschneiden",
		"Ausschneiden",
		"Ausschneiden",
		"Ausschneiden",
		"&&Kopieren",
		"Kopieren",
		"Kopieren",
		"Kopieren",
		"&&Einfügen",
		"Einfügen",
		"Einfügen",
		"Einfügen",
		"Mit Syntaxhervorhebung kopieren",
		"Kopieren als",
		"Kopieren als",
		"Freigeben",
		"Freigeben",
		"Freigeben",
	],
	"vs/editor/contrib/codeAction/browser/codeAction": [
		"Beim Anwenden der Code-Aktion ist ein unbekannter Fehler aufgetreten",
	],
	"vs/editor/contrib/codeAction/browser/codeActionCommands": [
		"Art der auszuführenden Codeaktion",
		"Legt fest, wann die zurückgegebenen Aktionen angewendet werden",
		"Die erste zurückgegebene Codeaktion immer anwenden",
		"Die erste zurückgegebene Codeaktion anwenden, wenn nur eine vorhanden ist",
		"Zurückgegebene Codeaktionen nicht anwenden",
		"Legt fest, ob nur bevorzugte Codeaktionen zurückgegeben werden sollen",
		"Schnelle Problembehebung ...",
		"Keine Codeaktionen verfügbar",
		"Keine bevorzugten Codeaktionen für \"{0}\" verfügbar",
		"Keine Codeaktionen für \"{0}\" verfügbar",
		"Keine bevorzugten Codeaktionen verfügbar",
		"Keine Codeaktionen verfügbar",
		"Refactoring durchführen...",
		"Keine bevorzugten Refactorings für \"{0}\" verfügbar",
		"Keine Refactorings für \"{0}\" verfügbar",
		"Keine bevorzugten Refactorings verfügbar",
		"Keine Refactorings verfügbar",
		"Quellaktion...",
		"Keine bevorzugten Quellaktionen für \"{0}\" verfügbar",
		"Keine Quellaktionen für \"{0}\" verfügbar",
		"Keine bevorzugten Quellaktionen verfügbar",
		"Keine Quellaktionen verfügbar",
		"Importe organisieren",
		"Keine Aktion zum Organisieren von Importen verfügbar",
		"Alle korrigieren",
		"Aktion \"Alle korrigieren\" nicht verfügbar",
		"Automatisch korrigieren...",
		"Keine automatischen Korrekturen verfügbar",
	],
	"vs/editor/contrib/codeAction/browser/codeActionContributions": [
		"Aktivieren/Deaktivieren Sie die Anzeige von Gruppenheadern im Codeaktionsmenü.",
		"Hiermit aktivieren/deaktivieren Sie die Anzeige der nächstgelegenen schnellen Problembehebung innerhalb einer Zeile, wenn derzeit keine Diagnose durchgeführt wird.",
	],
	"vs/editor/contrib/codeAction/browser/codeActionController": [
		"Kontext: {0} in Zeile {1} und Spalte {2}.",
		"Deaktivierte Elemente ausblenden",
		"Deaktivierte Elemente anzeigen",
	],
	"vs/editor/contrib/codeAction/browser/codeActionMenu": [
		"Weitere Aktionen...",
		"Schnelle Problembehebung",
		"Extrahieren",
		"Inline",
		"Erneut generieren",
		"Verschieben",
		"Umgeben mit",
		"Quellaktion",
	],
	"vs/editor/contrib/codeAction/browser/lightBulbWidget": [
		"Ausführen: {0}",
		"Zeigt Codeaktionen an. Bevorzugte Schnellkorrektur verfügbar ({0})",
		"Codeaktionen anzeigen ({0})",
		"Codeaktionen anzeigen",
	],
	"vs/editor/contrib/codelens/browser/codelensController": [
		"CodeLens-Befehle für aktuelle Zeile anzeigen",
		"Befehl auswählen",
	],
	"vs/editor/contrib/colorPicker/browser/colorPickerWidget": [
		"Zum Umschalten zwischen Farboptionen (rgb/hsl/hex) klicken",
		"Symbol zum Schließen des Farbwählers",
	],
	"vs/editor/contrib/colorPicker/browser/standaloneColorPickerActions": [
		"&&Eigenständige Farbwähler anzeigen oder fokussieren",
		"Farbwähler ausblenden",
		"Farbe mit eigenständigem Farbwähler einfügen",
		"Eigenständige Farbwähler anzeigen oder konzentrieren",
		"Show or focus a standalone color picker which uses the default color provider. It displays hex/rgb/hsl colors.",
		"Hide the standalone color picker.",
		"Insert hex/rgb/hsl colors with the focused standalone color picker.",
	],
	"vs/editor/contrib/comment/browser/comment": [
		"Zeilenkommentar umschalten",
		"Zeilenkommen&&tar umschalten",
		"Zeilenkommentar hinzufügen",
		"Zeilenkommentar entfernen",
		"Blockkommentar umschalten",
		"&&Blockkommentar umschalten",
	],
	"vs/editor/contrib/contextmenu/browser/contextmenu": [
		"Minimap",
		"Zeichen rendern",
		"Vertikale Größe",
		"Proportional",
		"Ausfüllen",
		"Anpassen",
		"Schieberegler",
		"Maus über",
		"Immer",
		"Editor-Kontextmenü anzeigen",
	],
	"vs/editor/contrib/cursorUndo/browser/cursorUndo": [
		"Mit Cursor rückgängig machen",
		"Wiederholen mit Cursor",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/copyPasteContribution": [
		"The kind of the paste edit to try applying. If not provided or there are multiple edits for this kind, the editor will show a picker.",
		"Einfügen als...",
		"Als Text einfügen",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/copyPasteController": [
		"Gibt an, ob das Einfügewidget angezeigt wird.",
		"Einfügeoptionen anzeigen...",
		"Es wurden keine Einfügebearbeitungen für „{0}“ gefunden.",
		"Einfügehandler werden ausgeführt. Klicken Sie hier, um den Vorgang abzubrechen.",
		"Einfügeaktion auswählen",
		"Einfügehandler werden ausgeführt",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/defaultProviders": [
		"Nur-Text einfügen",
		"URI einfügen",
		"URI einfügen",
		"Pfade einfügen",
		"Pfad einfügen",
		"Relative Pfade einfügen",
		"Relativen Pfad einfügen",
		"HTML einfügen",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/dropIntoEditorContribution": [
		"Konfiguriert den Standardablageanbieter für den Inhalt eines vorgegebenen MIME-Typs.",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/dropIntoEditorController": [
		"Gibt an, ob das Ablagewidget angezeigt wird.",
		"Ablageoptionen anzeigen...",
		"Drophandler werden ausgeführt. Klicken Sie hier, um den Vorgang abzubrechen.",
	],
	"vs/editor/contrib/editorState/browser/keybindingCancellation": [
		"Gibt an, ob der Editor einen abbrechbaren Vorgang ausführt, z. B. \"Verweisvorschau\".",
	],
	"vs/editor/contrib/find/browser/findController": [
		"Die Datei ist zu groß, um einen Vorgang zum Ersetzen aller Elemente auszuführen.",
		"Suchen",
		"&&Suchen",
		"Mit Argumenten suchen",
		"Mit Auswahl suchen",
		"Weitersuchen",
		"Vorheriges Element suchen",
		"Zu Übereinstimmung wechseln ...",
		"Keine Übereinstimmungen. Versuchen Sie, nach etwas anderem zu suchen.",
		"Geben Sie eine Zahl ein, um zu einer bestimmten Übereinstimmung zu wechseln (zwischen 1 und {0}).",
		"Zahl zwischen 1 und {0} eingeben",
		"Zahl zwischen 1 und {0} eingeben",
		"Nächste Auswahl suchen",
		"Vorherige Auswahl suchen",
		"Ersetzen",
		"&&Ersetzen",
	],
	"vs/editor/contrib/find/browser/findWidget": [
		"Symbol für \"In Auswahl suchen\" im Editor-Such-Widget.",
		"Symbol für die Anzeige, dass das Editor-Such-Widget zugeklappt wurde.",
		"Symbol für die Anzeige, dass das Editor-Such-Widget aufgeklappt wurde.",
		"Symbol für \"Ersetzen\" im Editor-Such-Widget.",
		"Symbol für \"Alle ersetzen\" im Editor-Such-Widget.",
		"Symbol für \"Vorheriges Element suchen\" im Editor-Such-Widget.",
		"Symbol für \"Nächstes Element suchen\" im Editor-Such-Widget.",
		"Suchen/Ersetzen",
		"Suchen",
		"Suchen",
		"Vorherige Übereinstimmung",
		"Nächste Übereinstimmung",
		"In Auswahl suchen",
		"Schließen",
		"Ersetzen",
		"Ersetzen",
		"Ersetzen",
		"Alle ersetzen",
		"Ersetzen umschalten",
		"Nur die ersten {0} Ergebnisse wurden hervorgehoben, aber alle Suchoperationen werden auf dem gesamten Text durchgeführt.",
		"{0} von {1}",
		"Keine Ergebnisse",
		"{0} gefunden",
		"{0} für \"{1}\" gefunden",
		"{0} für \"{1}\" gefunden, bei {2}",
		"{0} für \"{1}\" gefunden",
		"STRG+EINGABE fügt jetzt einen Zeilenumbruch ein, statt alles zu ersetzen. Sie können die Tastenzuordnung für \"editor.action.replaceAll\" ändern, um dieses Verhalten außer Kraft zu setzen.",
	],
	"vs/editor/contrib/folding/browser/folding": [
		"Auffalten",
		"Faltung rekursiv aufheben",
		"Falten",
		"Einklappung umschalten",
		"Rekursiv falten",
		"Alle Blockkommentare falten",
		"Alle Regionen falten",
		"Alle Regionen auffalten",
		"Alle bis auf ausgewählte falten",
		"Alle bis auf ausgewählte auffalten",
		"Alle falten",
		"Alle auffalten",
		"Zur übergeordneten Reduzierung wechseln",
		"Zum vorherigen Faltbereich wechseln",
		"Zum nächsten Faltbereich wechseln",
		"Faltungsbereich aus Auswahl erstellen",
		"Manuelle Faltbereiche entfernen",
		"Faltebene {0}",
	],
	"vs/editor/contrib/folding/browser/foldingDecorations": [
		"Hintergrundfarbe hinter gefalteten Bereichen. Die Farbe darf nicht deckend sein, sodass zugrunde liegende Dekorationen nicht ausgeblendet werden.",
		"Farbe des Faltsteuerelements im Editor-Bundsteg.",
		"Symbol für aufgeklappte Bereiche im Editor-Glyphenrand.",
		"Symbol für zugeklappte Bereiche im Editor-Glyphenrand.",
		"Symbol für manuell reduzierte Bereiche im Glyphenrand des Editors.",
		"Symbol für manuell erweiterte Bereiche im Glyphenrand des Editors.",
		"Klicken Sie hier, um den Bereich zu erweitern.",
		"Klicken Sie hier, um den Bereich zu reduzieren.",
	],
	"vs/editor/contrib/fontZoom/browser/fontZoom": [
		"Schriftgrad des Editors erhöhen",
		"Schriftgrad des Editors verringern",
		"Editor-Schriftgrad zurücksetzen",
	],
	"vs/editor/contrib/format/browser/formatActions": [
		"Dokument formatieren",
		"Auswahl formatieren",
	],
	"vs/editor/contrib/gotoError/browser/gotoError": [
		"Gehe zu nächstem Problem (Fehler, Warnung, Information)",
		"Symbol für den Marker zum Wechseln zum nächsten Element.",
		"Gehe zu vorigem Problem (Fehler, Warnung, Information)",
		"Symbol für den Marker zum Wechseln zum vorherigen Element.",
		"Gehe zu dem nächsten Problem in den Dateien (Fehler, Warnung, Info)",
		"Nächstes &&Problem",
		"Gehe zu dem vorherigen Problem in den Dateien (Fehler, Warnung, Info)",
		"Vorheriges &&Problem",
	],
	"vs/editor/contrib/gotoError/browser/gotoErrorWidget": [
		"Fehler",
		"Warnung",
		"Info",
		"Hinweis",
		"{0} bei {1}. ",
		"{0} von {1} Problemen",
		"{0} von {1} Problemen",
		"Editormarkierung: Farbe bei Fehler des Navigationswidgets.",
		"Hintergrund der Fehlerüberschrift des Markernavigationswidgets im Editor.",
		"Editormarkierung: Farbe bei Warnung des Navigationswidgets.",
		"Hintergrund der Warnungsüberschrift des Markernavigationswidgets im Editor.",
		"Editormarkierung: Farbe bei Information des Navigationswidgets.",
		"Hintergrund der Informationsüberschrift des Markernavigationswidgets im Editor.",
		"Editormarkierung: Hintergrund des Navigationswidgets.",
	],
	"vs/editor/contrib/gotoSymbol/browser/goToCommands": [
		"Vorschau",
		"Definitionen",
		"Keine Definition gefunden für \"{0}\".",
		"Keine Definition gefunden",
		"Gehe &&zu Definition",
		"Deklarationen",
		"Keine Deklaration für \"{0}\" gefunden.",
		"Keine Deklaration gefunden.",
		"Gehe zu &&Deklaration",
		"Keine Deklaration für \"{0}\" gefunden.",
		"Keine Deklaration gefunden.",
		"Typdefinitionen",
		"Keine Typendefinition gefunden für \"{0}\"",
		"Keine Typendefinition gefunden",
		"Zur &&Typdefinition wechseln",
		"Implementierungen",
		"Keine Implementierung gefunden für \"{0}\"",
		"Keine Implementierung gefunden",
		"Gehe zu &&Implementierungen",
		"Für \"{0}\" wurden keine Verweise gefunden.",
		"Keine Referenzen gefunden",
		"Gehe zu &&Verweisen",
		"Verweise",
		"Verweise",
		"Speicherorte",
		"Keine Ergebnisse für \"{0}\"",
		"Verweise",
		"Gehe zu Definition",
		"Definition an der Seite öffnen",
		"Definition einsehen",
		"Zur Deklaration wechseln",
		"Vorschau für Deklaration anzeigen",
		"Zur Typdefinition wechseln",
		"Vorschau der Typdefinition anzeigen",
		"Gehe zu Implementierungen",
		"Vorschau für Implementierungen anzeigen",
		"Gehe zu Verweisen",
		"Vorschau für Verweise anzeigen",
		"Zum beliebigem Symbol wechseln",
	],
	"vs/editor/contrib/gotoSymbol/browser/link/goToDefinitionAtPosition": [
		"Klicken Sie, um {0} Definitionen anzuzeigen.",
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesController": [
		"Gibt an, ob die Verweisvorschau sichtbar ist, z. B. \"Verweisvorschau\" oder \"Definition einsehen\".",
		"Wird geladen...",
		"{0} ({1})",
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesTree": [
		"{0} Verweise",
		"{0} Verweis",
		"Verweise",
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesWidget": [
		"Keine Vorschau verfügbar.",
		"Keine Ergebnisse",
		"Verweise",
	],
	"vs/editor/contrib/gotoSymbol/browser/referencesModel": [
		"in {0} in Zeile {1} in Spalte {2}",
		"{0} in {1} in Zeile {2} in Spalte {3}",
		"1 Symbol in {0}, vollständiger Pfad {1}",
		"{0} Symbole in {1}, vollständiger Pfad {2}",
		"Es wurden keine Ergebnisse gefunden.",
		"1 Symbol in {0} gefunden",
		"{0} Symbole in {1} gefunden",
		"{0} Symbole in {1} Dateien gefunden",
	],
	"vs/editor/contrib/gotoSymbol/browser/symbolNavigation": [
		"Gibt an, ob Symbolpositionen vorliegen, bei denen die Navigation nur über die Tastatur möglich ist.",
		"Symbol {0} von {1}, {2} für nächstes",
		"Symbol {0} von {1}",
	],
	"vs/editor/contrib/hover/browser/hoverActions": [
		"Show or Focus Hover",
		"The hover will not automatically take focus.",
		"The hover will take focus only if it is already visible.",
		"The hover will automatically take focus when it appears.",
		"Show Definition Preview Hover",
		"Scroll Up Hover",
		"Scroll Down Hover",
		"Scroll Left Hover",
		"Scroll Right Hover",
		"Page Up Hover",
		"Page Down Hover",
		"Go To Top Hover",
		"Go To Bottom Hover",
		"Increase Hover Verbosity Level",
		"Decrease Hover Verbosity Level",
		"Show or focus the editor hover which shows documentation, references, and other content for a symbol at the current cursor position.",
		"Show the definition preview hover in the editor.",
		"Scroll up the editor hover.",
		"Scroll down the editor hover.",
		"Scroll left the editor hover.",
		"Scroll right the editor hover.",
		"Page up the editor hover.",
		"Page down the editor hover.",
		"Go to the top of the editor hover.",
		"Go to the bottom of the editor hover.",
	],
	"vs/editor/contrib/hover/browser/markdownHoverParticipant": [
		"Icon for increaseing hover verbosity.",
		"Icon for decreasing hover verbosity.",
		"Wird geladen...",
		"Das Rendering langer Zeilen wurde aus Leistungsgründen angehalten. Dies kann über „editor.stopRenderingLineAfter“ konfiguriert werden.",
		"Die Tokenisierung wird bei langen Zeilen aus Leistungsgründen übersprungen. Dies kann über „editor.maxTokenizationLineLength“ konfiguriert werden.",
		"Increase Verbosity ({0})",
		"Increase Verbosity",
		"Decrease Verbosity ({0})",
		"Decrease Verbosity",
	],
	"vs/editor/contrib/hover/browser/markerHoverParticipant": [
		"Problem anzeigen",
		"Keine Schnellkorrekturen verfügbar",
		"Es wird nach Schnellkorrekturen gesucht...",
		"Keine Schnellkorrekturen verfügbar",
		"Schnelle Problembehebung ...",
	],
	"vs/editor/contrib/inPlaceReplace/browser/inPlaceReplace": [
		"Durch vorherigen Wert ersetzen",
		"Durch nächsten Wert ersetzen",
	],
	"vs/editor/contrib/indentation/browser/indentation": [
		"Einzug in Leerzeichen konvertieren",
		"Einzug in Tabstopps konvertieren",
		"Konfigurierte Tabulatorgröße",
		"Standardregisterkartengröße",
		"Aktuelle Registerkartengröße",
		"Tabulatorgröße für aktuelle Datei auswählen",
		"Einzug mithilfe von Tabstopps",
		"Einzug mithilfe von Leerzeichen",
		"Anzeigegröße der Registerkarte ändern",
		"Einzug aus Inhalt erkennen",
		"Neuen Einzug für Zeilen festlegen",
		"Gewählte Zeilen zurückziehen",
		"Convert the tab indentation to spaces.",
		"Convert the spaces indentation to tabs.",
		"Use indentation with tabs.",
		"Use indentation with spaces.",
		"Change the space size equivalent of the tab.",
		"Detect the indentation from content.",
		"Reindent the lines of the editor.",
		"Reindent the selected lines of the editor.",
	],
	"vs/editor/contrib/inlayHints/browser/inlayHintsHover": [
		"Zum Einfügen doppelklicken",
		"BEFEHL + Klicken",
		"STRG + Klicken",
		"OPTION + Klicken",
		"ALT + Klicken",
		"Wechseln Sie zu Definition ({0}), klicken Sie mit der rechten Maustaste, um weitere Informationen zu finden.",
		"Gehe zu Definition ({0})",
		"Befehl ausführen",
	],
	"vs/editor/contrib/inlineCompletions/browser/commands": [
		"Nächsten Inline-Vorschlag anzeigen",
		"Vorherigen Inline-Vorschlag anzeigen",
		"Inline-Vorschlag auslösen",
		"Nächstes Wort des Inline-Vorschlags annehmen",
		"Wort annehmen",
		"Nächste Zeile des Inlinevorschlags akzeptieren",
		"Zeile annehmen",
		"Inline-Vorschlag annehmen",
		"Annehmen",
		"Inlinevorschlag ausblenden",
		"Symbolleiste immer anzeigen",
	],
	"vs/editor/contrib/inlineCompletions/browser/hoverParticipant": [
		"Vorschlag:",
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionContextKeys": [
		"Gibt an, ob ein Inline-Vorschlag sichtbar ist.",
		"Gibt an, ob der Inline-Vorschlag mit Leerzeichen beginnt.",
		"Ob der Inline-Vorschlag mit Leerzeichen beginnt, das kleiner ist als das, was durch die Tabulatortaste eingefügt werden würde",
		"Gibt an, ob Vorschläge für den aktuellen Vorschlag unterdrückt werden sollen",
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionsController": [
		"Überprüfen Sie dies in der barrierefreien Ansicht ({0}).",
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionsHintsWidget": [
		"Symbol für die Anzeige des nächsten Parameterhinweises.",
		"Symbol für die Anzeige des vorherigen Parameterhinweises.",
		"{0} ({1})",
		"Zurück",
		"Weiter",
	],
	"vs/editor/contrib/lineSelection/browser/lineSelection": [
		"Zeilenauswahl erweitern",
	],
	"vs/editor/contrib/linesOperations/browser/linesOperations": [
		"Zeile nach oben kopieren",
		"Zeile nach oben &&kopieren",
		"Zeile nach unten kopieren",
		"Zeile nach unten ko&&pieren",
		"Auswahl duplizieren",
		"&&Auswahl duplizieren",
		"Zeile nach oben verschieben",
		"Zeile nach oben &&verschieben",
		"Zeile nach unten verschieben",
		"Zeile nach &&unten verschieben",
		"Zeilen aufsteigend sortieren",
		"Zeilen absteigend sortieren",
		"Doppelte Zeilen löschen",
		"Nachgestelltes Leerzeichen kürzen",
		"Zeile löschen",
		"Zeileneinzug",
		"Zeile ausrücken",
		"Zeile oben einfügen",
		"Zeile unten einfügen",
		"Alle übrigen löschen",
		"Alle rechts löschen",
		"Zeilen verknüpfen",
		"Zeichen um den Cursor herum transponieren",
		"In Großbuchstaben umwandeln",
		"In Kleinbuchstaben umwandeln",
		"In große Anfangsbuchstaben umwandeln",
		"In Snake Case umwandeln",
		"In CamelCase umwandeln",
		"Transform to Pascal Case",
		"In kebab-case umwandeln",
	],
	"vs/editor/contrib/linkedEditing/browser/linkedEditing": [
		"Verknüpfte Bearbeitung starten",
		"Hintergrundfarbe, wenn der Editor automatisch nach Typ umbenennt.",
	],
	"vs/editor/contrib/links/browser/links": [
		"Fehler beim Öffnen dieses Links, weil er nicht wohlgeformt ist: {0}",
		"Fehler beim Öffnen dieses Links, weil das Ziel fehlt.",
		"Befehl ausführen",
		"Link folgen",
		"BEFEHL + Klicken",
		"STRG + Klicken",
		"OPTION + Klicken",
		"alt + klicken",
		"Führen Sie den Befehl \"{0}\" aus.",
		"Link öffnen",
	],
	"vs/editor/contrib/message/browser/messageController": [
		"Gibt an, ob der Editor zurzeit eine Inlinenachricht anzeigt.",
	],
	"vs/editor/contrib/multicursor/browser/multicursor": [
		"Hinzugefügter Cursor: {0}",
		"Hinzugefügte Cursor: {0}",
		"Cursor oberhalb hinzufügen",
		"Cursor oberh&&alb hinzufügen",
		"Cursor unterhalb hinzufügen",
		"Cursor unterhal&&b hinzufügen",
		"Cursor an Zeilenenden hinzufügen",
		"C&&ursor an Zeilenenden hinzufügen",
		"Cursor am Ende hinzufügen",
		"Cursor am Anfang hinzufügen",
		"Auswahl zur nächsten Übereinstimmungssuche hinzufügen",
		"&&Nächstes Vorkommen hinzufügen",
		"Letzte Auswahl zu vorheriger Übereinstimmungssuche hinzufügen",
		"Vo&&rheriges Vorkommen hinzufügen",
		"Letzte Auswahl in nächste Übereinstimmungssuche verschieben",
		"Letzte Auswahl in vorherige Übereinstimmungssuche verschieben",
		"Alle Vorkommen auswählen und Übereinstimmung suchen",
		"Alle V&&orkommen auswählen",
		"Alle Vorkommen ändern",
		"Fokus auf nächsten Cursor",
		"Fokussiert den nächsten Cursor",
		"Fokus auf vorherigen Cursor",
		"Fokussiert den vorherigen Cursor",
	],
	"vs/editor/contrib/parameterHints/browser/parameterHints": [
		"Parameterhinweise auslösen",
	],
	"vs/editor/contrib/parameterHints/browser/parameterHintsWidget": [
		"Symbol für die Anzeige des nächsten Parameterhinweises.",
		"Symbol für die Anzeige des vorherigen Parameterhinweises.",
		"{0}, Hinweis",
		"Vordergrundfarbe des aktiven Elements im Parameterhinweis.",
	],
	"vs/editor/contrib/peekView/browser/peekView": [
		"Gibt an, ob der aktuelle Code-Editor in der Vorschau eingebettet ist.",
		"Schließen",
		"Hintergrundfarbe des Titelbereichs der Peek-Ansicht.",
		"Farbe des Titels in der Peek-Ansicht.",
		"Farbe der Titelinformationen in der Peek-Ansicht.",
		"Farbe der Peek-Ansichtsränder und des Pfeils.",
		"Hintergrundfarbe der Ergebnisliste in der Peek-Ansicht.",
		"Vordergrundfarbe für Zeilenknoten in der Ergebnisliste der Peek-Ansicht.",
		"Vordergrundfarbe für Dateiknoten in der Ergebnisliste der Peek-Ansicht.",
		"Hintergrundfarbe des ausgewählten Eintrags in der Ergebnisliste der Peek-Ansicht.",
		"Vordergrundfarbe des ausgewählten Eintrags in der Ergebnisliste der Peek-Ansicht.",
		"Hintergrundfarbe des Peek-Editors.",
		"Hintergrundfarbe der Leiste im Peek-Editor.",
		"Die Hintergrundfarbe für den „Sticky“-Bildlaufeffekt im Editor für die „Peek“-Ansicht.",
		"Farbe für Übereinstimmungsmarkierungen in der Ergebnisliste der Peek-Ansicht.",
		"Farbe für Übereinstimmungsmarkierungen im Peek-Editor.",
		"Rahmen für Übereinstimmungsmarkierungen im Peek-Editor.",
	],
	"vs/editor/contrib/quickAccess/browser/gotoLineQuickAccess": [
		"Öffnen Sie zuerst einen Text-Editor, um zu einer Zeile zu wechseln.",
		"Wechseln Sie zu Zeile {0} und Zeichen {1}.",
		"Zu Zeile {0} wechseln.",
		"Aktuelle Zeile: {0}, Zeichen: {1}. Geben Sie eine Zeilennummer zwischen 1 und {2} ein, zu der Sie navigieren möchten.",
		"Aktuelle Zeile: {0}, Zeichen: {1}. Geben Sie eine Zeilennummer ein, zu der Sie navigieren möchten.",
	],
	"vs/editor/contrib/quickAccess/browser/gotoSymbolQuickAccess": [
		"Öffnen Sie zunächst einen Text-Editor mit Symbolinformationen, um zu einem Symbol zu navigieren.",
		"Der aktive Text-Editor stellt keine Symbolinformationen bereit.",
		"Keine übereinstimmenden Editorsymbole.",
		"Keine Editorsymbole.",
		"An der Seite öffnen",
		"Unten öffnen",
		"Symbole ({0})",
		"Eigenschaften ({0})",
		"Methoden ({0})",
		"Funktionen ({0})",
		"Konstruktoren ({0})",
		"Variablen ({0})",
		"Klassen ({0})",
		"Strukturen ({0})",
		"Ereignisse ({0})",
		"Operatoren ({0})",
		"Schnittstellen ({0})",
		"Namespaces ({0})",
		"Pakete ({0})",
		"Typparameter ({0})",
		"Module ({0})",
		"Eigenschaften ({0})",
		"Enumerationen ({0})",
		"Enumerationsmember ({0})",
		"Zeichenfolgen ({0})",
		"Dateien ({0})",
		"Arrays ({0})",
		"Zahlen ({0})",
		"Boolesche Werte ({0})",
		"Objekte ({0})",
		"Schlüssel ({0})",
		"Felder ({0})",
		"Konstanten ({0})",
	],
	"vs/editor/contrib/readOnlyMessage/browser/contribution": [
		"Bearbeitung von schreibgeschützter Eingabe nicht möglich",
		"Ein Bearbeiten ist im schreibgeschützten Editor nicht möglich",
	],
	"vs/editor/contrib/rename/browser/rename": [
		"Kein Ergebnis.",
		"Ein unbekannter Fehler ist beim Auflösen der Umbenennung eines Ortes aufgetreten.",
		"\'{0}\' wird in \'{1}\' umbenannt",
		"{0} wird in {1} umbenannt.",
		"\"{0}\" erfolgreich in \"{1}\" umbenannt. Zusammenfassung: {2}",
		"Die rename-Funktion konnte die Änderungen nicht anwenden.",
		"Die rename-Funktion konnte die Änderungen nicht berechnen.",
		"Symbol umbenennen",
		"Möglichkeit aktivieren/deaktivieren, Änderungen vor dem Umbenennen als Vorschau anzeigen zu lassen",
		"Nächsten Umbenennungsvorschlag fokussieren",
		"Vorherigen Umbenennungsvorschlag fokussieren",
	],
	"vs/editor/contrib/rename/browser/renameWidget": [
		"Whether the rename input widget is visible",
		"Whether the rename input widget is focused",
		"{0} to Rename, {1} to Preview",
		"Received {0} rename suggestions",
		"Rename input. Type new name and press Enter to commit.",
	],
	"vs/editor/contrib/smartSelect/browser/smartSelect": [
		"Auswahl aufklappen",
		"Auswahl &&erweitern",
		"Markierung verkleinern",
		"Au&&swahl verkleinern",
	],
	"vs/editor/contrib/snippet/browser/snippetController2": [
		"Gibt an, ob der Editor sich zurzeit im Schnipselmodus befindet.",
		"Gibt an, ob ein nächster Tabstopp im Schnipselmodus vorhanden ist.",
		"Gibt an, ob ein vorheriger Tabstopp im Schnipselmodus vorhanden ist.",
		"Zum nächsten Platzhalter wechseln...",
	],
	"vs/editor/contrib/snippet/browser/snippetVariables": [
		"Sonntag",
		"Montag",
		"Dienstag",
		"Mittwoch",
		"Donnerstag",
		"Freitag",
		"Samstag",
		"So",
		"Mo",
		"Di",
		"Mi",
		"Do",
		"Fr",
		"Sa",
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember",
		"Jan",
		"Feb",
		"Mär",
		"Apr",
		"Mai",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Okt",
		"Nov",
		"Dez",
	],
	"vs/editor/contrib/stickyScroll/browser/stickyScrollActions": [
		"Fixierten Bildlauf des Editors &&umschalten",
		"Fixierter Bildlauf",
		"&&Fixierter Bildlauf",
		"&&Fokus fixierter Bildlauf",
		"Toggle/enable the editor sticky scroll which shows the nested scopes at the top of the viewport.",
		"Focus on the editor sticky scroll",
		"Select the next editor sticky scroll line",
		"Select the previous sticky scroll line",
		"Go to the focused sticky scroll line",
		"Editor auswählen",
	],
	"vs/editor/contrib/suggest/browser/suggest": [
		"Gibt an, ob ein Vorschlag fokussiert ist",
		"Gibt an, ob Vorschlagsdetails sichtbar sind.",
		"Gibt an, ob mehrere Vorschläge zur Auswahl stehen.",
		"Gibt an, ob das Einfügen des aktuellen Vorschlags zu einer Änderung führt oder ob bereits alles eingegeben wurde.",
		"Gibt an, ob Vorschläge durch Drücken der EINGABETASTE eingefügt werden.",
		"Gibt an, ob der aktuelle Vorschlag Verhalten zum Einfügen und Ersetzen aufweist.",
		"Gibt an, ob Einfügen oder Ersetzen als Standardverhalten verwendet wird.",
		"Gibt an, ob der aktuelle Vorschlag die Auflösung weiterer Details unterstützt.",
	],
	"vs/editor/contrib/suggest/browser/suggestController": [
		"Das Akzeptieren von \"{0}\" ergab {1} zusätzliche Bearbeitungen.",
		"Vorschlag auslösen",
		"Einfügen",
		"Einfügen",
		"Ersetzen",
		"Ersetzen",
		"Einfügen",
		"weniger anzeigen",
		"mehr anzeigen",
		"Größe des Vorschlagswidgets zurücksetzen",
	],
	"vs/editor/contrib/suggest/browser/suggestWidget": [
		"Hintergrundfarbe des Vorschlagswidgets.",
		"Rahmenfarbe des Vorschlagswidgets.",
		"Vordergrundfarbe des Vorschlagswidgets.",
		"Die Vordergrundfarbe des ausgewählten Eintrags im Vorschlagswidget.",
		"Die Vordergrundfarbe des Symbols des ausgewählten Eintrags im Vorschlagswidget.",
		"Hintergrundfarbe des ausgewählten Eintrags im Vorschlagswidget.",
		"Farbe der Trefferhervorhebung im Vorschlagswidget.",
		"Die Farbe des Treffers wird im Vorschlagswidget hervorgehoben, wenn ein Element fokussiert wird.",
		"Vordergrundfarbe des Status des Vorschlagswidgets.",
		"Wird geladen...",
		"Keine Vorschläge.",
		"Vorschlagen",
		"{0} {1}, {2}",
		"{0} {1}",
		"{0}, {1}",
		"{0}, Dokumente: {1}",
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetDetails": [
		"Schließen",
		"Wird geladen...",
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetRenderer": [
		"Symbol für weitere Informationen im Vorschlags-Widget.",
		"Weitere Informationen",
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetStatus": [
		"{0} ({1})",
	],
	"vs/editor/contrib/symbolIcons/browser/symbolIcons": [
		"Die Vordergrundfarbe für Arraysymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für boolesche Symbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Klassensymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Farbsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für konstante Symbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Konstruktorsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Enumeratorsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Enumeratormembersymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Ereignissymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Feldsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Dateisymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Ordnersymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Funktionssymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Schnittstellensymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Schlüsselsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Schlüsselwortsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Methodensymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Modulsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Namespacesymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für NULL-Symbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Zahlensymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Objektsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Operatorsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Paketsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Eigenschaftensymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Referenzsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Codeschnipselsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Zeichenfolgensymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Struktursymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Textsymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Typparametersymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für Einheitensymbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
		"Die Vordergrundfarbe für variable Symbole. Diese Symbole werden in den Widgets für Gliederung, Breadcrumbs und Vorschläge angezeigt.",
	],
	"vs/editor/contrib/toggleTabFocusMode/browser/toggleTabFocusMode": [
		"Beim Drücken auf Tab wird der Fokus jetzt auf das nächste fokussierbare Element verschoben",
		"Beim Drücken von Tab wird jetzt das Tabulator-Zeichen eingefügt",
		"TAB-Umschalttaste verschiebt Fokus",
		"Determines whether the tab key moves focus around the workbench or inserts the tab character in the current editor. This is also called tab trapping, tab navigation, or tab focus mode.",
	],
	"vs/editor/contrib/tokenization/browser/tokenization": [
		"Entwickler: Force Retokenize",
	],
	"vs/editor/contrib/unicodeHighlighter/browser/unicodeHighlighter": [
		"Symbol, das mit einer Warnmeldung im Erweiterungs-Editor angezeigt wird.",
		"Dieses Dokument enthält viele nicht einfache ASCII-Unicode-Zeichen.",
		"Dieses Dokument enthält viele mehrdeutige Unicode-Zeichen.",
		"Dieses Dokument enthält viele unsichtbare Unicode-Zeichen.",
		"Konfigurieren der Optionen für die Unicode-Hervorhebung",
		"Das Zeichen {0} kann mit dem Zeichen {1} verwechselt werden, was im Quellcode häufiger vorkommt.",
		"Das Zeichen {0} kann mit dem Zeichen {1} verwechselt werden, was im Quellcode häufiger vorkommt.",
		"Das Zeichen {0} ist nicht sichtbar.",
		"Das Zeichen {0} ist kein einfaches ASCII-Zeichen.",
		"Einstellungen anpassen",
		"Hervorhebung in Kommentaren deaktivieren",
		"Deaktivieren der Hervorhebung von Zeichen in Kommentaren",
		"Hervorhebung in Zeichenfolgen deaktivieren",
		"Deaktivieren der Hervorhebung von Zeichen in Zeichenfolgen",
		"Mehrdeutige Hervorhebung deaktivieren",
		"Deaktivieren der Hervorhebung von mehrdeutigen Zeichen",
		"Unsichtbare Hervorhebung deaktivieren",
		"Deaktivieren der Hervorhebung unsichtbarer Zeichen",
		"Nicht-ASCII-Hervorhebung deaktivieren",
		"Deaktivieren der Hervorhebung von nicht einfachen ASCII-Zeichen",
		"Ausschlussoptionen anzeigen",
		"{0} (unsichtbares Zeichen) von der Hervorhebung ausschließen",
		"{0} nicht hervorheben",
		"Unicodezeichen zulassen, die in der Sprache „{0}“ häufiger vorkommen.",
	],
	"vs/editor/contrib/unusualLineTerminators/browser/unusualLineTerminators": [
		"Ungewöhnliche Zeilentrennzeichen",
		"Ungewöhnliche Zeilentrennzeichen erkannt",
		"Die Datei \"{0}\" enthält mindestens ein ungewöhnliches Zeilenabschlusszeichen, z. B. Zeilentrennzeichen (LS) oder Absatztrennzeichen (PS).\r\n\r\nEs wird empfohlen, sie aus der Datei zu entfernen. Dies kann über \"editor.unusualLineTerminators\" konfiguriert werden.",
		"&&Ungewöhnliche Zeilenabschlusszeichen entfernen",
		"Ignorieren",
	],
	"vs/editor/contrib/wordHighlighter/browser/highlightDecorations": [
		"Hintergrundfarbe eines Symbols beim Lesezugriff, z.B. beim Lesen einer Variablen. Die Farbe darf nicht deckend sein, damit sie nicht die zugrunde liegenden Dekorationen verdeckt.",
		"Hintergrundfarbe eines Symbols bei Schreibzugriff, z.B. beim Schreiben in eine Variable. Die Farbe darf nicht deckend sein, weil sie sonst die zugrunde liegenden Dekorationen verdeckt.",
		"Die Hintergrundfarbe eines Textteils für ein Symbol. Die Farbe darf nicht deckend sein, um zugrunde liegende Dekorationen nicht auszublenden.",
		"Randfarbe eines Symbols beim Lesezugriff, wie etwa beim Lesen einer Variablen.",
		"Randfarbe eines Symbols beim Schreibzugriff, wie etwa beim Schreiben einer Variablen.",
		"Die Rahmenfarbe eines Textteils für ein Symbol.",
		"Übersichtslinealmarkerfarbd für das Hervorheben von Symbolen. Die Farbe darf nicht deckend sein, weil sie sonst die zugrunde liegenden Dekorationen verdeckt.",
		"Übersichtslinealmarkerfarbe für Symbolhervorhebungen bei Schreibzugriff. Die Farbe darf nicht deckend sein, weil sie sonst die zugrunde liegenden Dekorationen verdeckt.",
		"Die Markierungsfarbe des Übersichtslineals eines Textteils für ein Symbol. Die Farbe darf nicht deckend sein, um zugrunde liegende Dekorationen nicht auszublenden.",
	],
	"vs/editor/contrib/wordHighlighter/browser/wordHighlighter": [
		"Gehe zur nächsten Symbolhervorhebungen",
		"Gehe zur vorherigen Symbolhervorhebungen",
		"Symbol-Hervorhebung ein-/ausschalten",
	],
	"vs/editor/contrib/wordOperations/browser/wordOperations": [
		"Wort löschen",
	],
	"vs/platform/accessibilitySignal/browser/accessibilitySignalService": [
		"Error at Position",
		"Error",
		"Warning at Position",
		"Warning",
		"Fehler in der Zeile",
		"Error on Line",
		"Warnung in der Zeile",
		"Warning on Line",
		"Gefalteter Bereich in der Zeile",
		"Gefaltet",
		"Haltepunkt in der Zeile",
		"Haltepunkt",
		"Inlinevorschlag in der Zeile",
		"Terminale schnelle Problembehebung",
		"Schnelle Problembehebung",
		"Debugger auf Haltepunkt beendet",
		"Haltepunkt",
		"Keine Inlay-Hinweise in der Zeile",
		"Keine Inlay-Hinweise",
		"Aufgabe abgeschlossen",
		"Aufgabe abgeschlossen",
		"Aufgabe fehlgeschlagen",
		"Fehler bei Aufgabe",
		"Terminalbefehl fehlgeschlagen",
		"Befehl fehlgeschlagen",
		"Terminalglocke",
		"Terminalglocke",
		"Notebookzelle abgeschlossen",
		"Notebookzelle abgeschlossen",
		"Notebookzelle fehlgeschlagen",
		"Notebookzelle fehlgeschlagen",
		"Vergleichslinie eingefügt",
		"Vergleichslinie gelöscht",
		"Vergleichslinie geändert",
		"Chatanfrage gesendet",
		"Chatanfrage gesendet",
		"Chatantwort empfangen",
		"Progress",
		"Progress",
		"Löschen",
		"Löschen",
		"Speichern",
		"Speichern",
		"Format",
		"Formatieren",
		"Voice Recording Started",
		"Voice Recording Stopped",
	],
	"vs/platform/action/common/actionCommonCategories": [
		"Ansehen",
		"Hilfe",
		"Test",
		"Datei",
		"Einstellungen",
		"Entwickler",
	],
	"vs/platform/actionWidget/browser/actionList": [
		"{0} to Apply, {1} to Preview",
		"{0} to Apply",
		"{0} deaktiviert, Grund: {1}",
		"Aktionswidget",
	],
	"vs/platform/actionWidget/browser/actionWidget": [
		"Hintergrundfarbe für umgeschaltete Aktionselemente in der Aktionsleiste.",
		"Gibt an, ob die Aktionswidgetliste sichtbar ist.",
		"Codeaktionswidget ausblenden",
		"Vorherige Aktion auswählen",
		"Nächste Aktion auswählen",
		"Ausgewählte Aktion akzeptieren",
		"Vorschau für ausgewählte Elemente anzeigen",
	],
	"vs/platform/actions/browser/menuEntryActionViewItem": [
		"{0} ({1})",
		"{0} ({1})",
		"{0}\r\n[{1}] {2}",
	],
	"vs/platform/actions/browser/toolbar": [
		"Ausblenden",
		"Menü zurücksetzen",
	],
	"vs/platform/actions/common/menuService": [
		"\"{0}\" ausblenden",
		"Configure Keybinding",
	],
	"vs/platform/configuration/common/configurationRegistry": [
		"Außerkraftsetzungen für die Standardsprachkonfiguration",
		"Konfigurieren Sie Einstellungen, die für die Sprache {0} überschrieben werden sollen.",
		"Zu überschreibende Editor-Einstellungen für eine Sprache konfigurieren.",
		"Diese Einstellung unterstützt keine sprachspezifische Konfiguration.",
		"Zu überschreibende Editor-Einstellungen für eine Sprache konfigurieren.",
		"Diese Einstellung unterstützt keine sprachspezifische Konfiguration.",
		"Eine leere Eigenschaft kann nicht registriert werden.",
		"\"{0}\" kann nicht registriert werden. Stimmt mit dem Eigenschaftsmuster \"\\\\[.*\\\\]$\" zum Beschreiben sprachspezifischer Editor-Einstellungen überein. Verwenden Sie den Beitrag \"configurationDefaults\".",
		"{0}\" kann nicht registriert werden. Diese Eigenschaft ist bereits registriert.",
		"\"{0}\" kann nicht registriert werden. Die zugeordnete Richtlinie {1} ist bereits bei {2} registriert.",
	],
	"vs/platform/contextkey/browser/contextKeyService": [
		"Ein Befehl, der Informationen zu Kontextschlüsseln zurückgibt",
	],
	"vs/platform/contextkey/common/contextkey": [
		"Leerer Kontextschlüsselausdruck",
		"Haben Sie vergessen, einen Ausdruck zu schreiben? Sie können auch „false“ oder „true“ festlegen, um immer auf „false“ oder „true“ auszuwerten.",
		"„in“ nach „not“.",
		"schließende Klammer „)“",
		"Unerwartetes Token",
		"Haben Sie vergessen, && oder || vor dem Token einzufügen?",
		"Unerwartetes Ende des Ausdrucks.",
		"Haben Sie vergessen, einen Kontextschlüssel zu setzen?",
		"Erwartet: {0}\r\nEmpfangen: „{1}“.",
	],
	"vs/platform/contextkey/common/contextkeys": [
		"Gibt an, ob macOS als Betriebssystem verwendet wird.",
		"Gibt an, ob Linux als Betriebssystem verwendet wird.",
		"Gibt an, ob Windows als Betriebssystem verwendet wird.",
		"Gibt an, ob es sich bei der Plattform um einen Webbrowser handelt.",
		"Gibt an, ob macOS auf einer Nicht-Browser-Plattform als Betriebssystem verwendet wird.",
		"Gibt an, ob iOS als Betriebssystem verwendet wird.",
		"Gibt an, ob es sich bei der Plattform um einen mobilen Webbrowser handelt.",
		"Qualitätstyp des VS Codes",
		"Gibt an, ob sich der Tastaturfokus in einem Eingabefeld befindet.",
	],
	"vs/platform/contextkey/common/scanner": [
		"Meinten Sie {0}?",
		"Meinten Sie {0} oder {1}?",
		"Meinten Sie {0}, {1} oder {2}?",
		"Haben Sie vergessen, das Anführungszeichen zu öffnen oder zu schließen?",
		"Haben Sie vergessen, das Zeichen „/“ (Schrägstrich) zu escapen? Setzen Sie zwei Backslashes davor, um es zu escapen, z. B. „\\\\/“.",
	],
	"vs/platform/history/browser/contextScopedHistoryWidget": [
		"Gibt an, ob Vorschläge sichtbar sind.",
	],
	"vs/platform/keybinding/common/abstractKeybindingService": [
		"({0}) wurde gedrückt. Es wird auf die zweite Taste in der Kombination gewartet...",
		"({0}) wurde gedrückt. Es wird auf die zweite Taste in der Kombination gewartet...",
		"Die Tastenkombination ({0}, {1}) ist kein Befehl.",
		"Die Tastenkombination ({0}, {1}) ist kein Befehl.",
	],
	"vs/platform/list/browser/listService": [
		"Workbench",
		"Ist unter Windows und Linux der STRG-Taste und unter macOS der Befehlstaste zugeordnet.",
		"Ist unter Windows und Linux der ALT-Taste und unter macOS der Wahltaste zugeordnet.",
		"Der Modifizierer zum Hinzufügen eines Elements in Bäumen und Listen zu einer Mehrfachauswahl mit der Maus (zum Beispiel im Explorer, in geöffneten Editoren und in der SCM-Ansicht). Die Mausbewegung \"Seitlich öffnen\" wird – sofern unterstützt – so angepasst, dass kein Konflikt mit dem Modifizierer für Mehrfachauswahl entsteht.",
		"Steuert, wie Elemente in Strukturen und Listen mithilfe der Maus geöffnet werden (sofern unterstützt). Bei übergeordneten Elementen, deren untergeordnete Elemente sich in Strukturen befinden, steuert diese Einstellung, ob ein Einfachklick oder ein Doppelklick das übergeordnete Elemente erweitert. Beachten Sie, dass einige Strukturen und Listen diese Einstellung ggf. ignorieren, wenn sie nicht zutrifft.",
		"Steuert, ob Listen und Strukturen ein horizontales Scrollen in der Workbench unterstützen. Warnung: Das Aktivieren dieser Einstellung kann sich auf die Leistung auswirken.",
		"Steuert, ob Klicks in der Bildlaufleiste Seite für Seite scrollen.",
		"Steuert den Struktureinzug in Pixeln.",
		"Steuert, ob die Struktur Einzugsführungslinien rendern soll.",
		"Steuert, ob Listen und Strukturen einen optimierten Bildlauf verwenden.",
		"Ein Multiplikator, der für die Mausrad-Bildlaufereignisse \"deltaX\" und \"deltaY\" verwendet werden soll.",
		"Multiplikator für Scrollgeschwindigkeit bei Drücken von ALT.",
		"Elemente beim Suchen hervorheben. Die Navigation nach oben und unten durchläuft dann nur die markierten Elemente.",
		"Filterelemente bei der Suche.",
		"Steuert den Standardsuchmodus für Listen und Strukturen in der Workbench.",
		"Bei der einfachen Tastaturnavigation werden Elemente in den Fokus genommen, die mit der Tastatureingabe übereinstimmen. Die Übereinstimmungen gelten nur für Präfixe.",
		"Hervorheben von Tastaturnavigationshervorgebungselemente, die mit der Tastatureingabe übereinstimmen. Beim nach oben und nach unten Navigieren werden nur die hervorgehobenen Elemente durchlaufen.",
		"Durch das Filtern der Tastaturnavigation werden alle Elemente herausgefiltert und ausgeblendet, die nicht mit der Tastatureingabe übereinstimmen.",
		"Steuert die Tastaturnavigation in Listen und Strukturen in der Workbench. Kann \"simple\" (einfach), \"highlight\" (hervorheben) und \"filter\" (filtern) sein.",
		"Bitte verwenden Sie stattdessen „workbench.list.defaultFindMode“ und „workbench.list.typeNavigationMode“.",
		"Verwenden Sie bei der Suche eine Fuzzyübereinstimmung.",
		"Verwenden Sie bei der Suche eine zusammenhängende Übereinstimmung.",
		"Steuert den Typ der Übereinstimmung, der beim Durchsuchen von Listen und Strukturen in der Workbench verwendet wird.",
		"Steuert, wie Strukturordner beim Klicken auf die Ordnernamen erweitert werden. Beachten Sie, dass einige Strukturen und Listen diese Einstellung ggf. ignorieren, wenn sie nicht zutrifft.",
		"Steuert, ob fester Bildlauf in Strukturen aktiviert ist.",
		"Steuert die Anzahl der festen Elemente, die in der Struktur angezeigt werden, wenn \"#workbench.tree.enableStickyScroll#\" aktiviert ist.",
		"Steuert die Funktionsweise der Typnavigation in Listen und Strukturen in der Workbench. Bei einer Festlegung auf \"trigger\" beginnt die Typnavigation, sobald der Befehl \"list.triggerTypeNavigation\" ausgeführt wird.",
	],
	"vs/platform/markers/common/markers": [
		"Fehler",
		"Warnung",
		"Info",
	],
	"vs/platform/quickinput/browser/commandsQuickAccess": [
		"zuletzt verwendet",
		"ähnliche Befehle",
		"häufig verwendet",
		"andere Befehle",
		"ähnliche Befehle",
		"{0}, {1}",
		"Der Befehl \"{0}\" hat zu einem Fehler geführt.",
	],
	"vs/platform/quickinput/browser/helpQuickAccess": [
		"{0}, {1}",
	],
	"vs/platform/quickinput/browser/quickInput": [
		"Zurück",
		"Drücken Sie die EINGABETASTE, um Ihre Eingabe zu bestätigen, oder ESC, um den Vorgang abzubrechen.",
		"{0}/{1}",
		"Nehmen Sie eine Eingabe vor, um die Ergebnisse einzugrenzen.",
	],
	"vs/platform/quickinput/browser/quickInputController": [
		"Aktivieren Sie alle Kontrollkästchen",
		"{0} Ergebnisse",
		"{0} ausgewählt",
		"OK",
		"Benutzerdefiniert",
		"Zurück ({0})",
		"Zurück",
	],
	"vs/platform/quickinput/browser/quickInputTree": [
		"Quick Input",
	],
	"vs/platform/quickinput/browser/quickInputUtils": [
		"Klicken, um den Befehl \"{0}\" auszuführen",
	],
	"vs/platform/theme/common/colors/baseColors": [
		"Overall foreground color. This color is only used if not overridden by a component.",
		"Overall foreground for disabled elements. This color is only used if not overridden by a component.",
		"Overall foreground color for error messages. This color is only used if not overridden by a component.",
		"Foreground color for description text providing additional information, for example for a label.",
		"The default color for icons in the workbench.",
		"Overall border color for focused elements. This color is only used if not overridden by a component.",
		"An extra border around elements to separate them from others for greater contrast.",
		"An extra border around active elements to separate them from others for greater contrast.",
		"The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor.",
		"Foreground color for links in text.",
		"Foreground color for links in text when clicked on and on mouse hover.",
		"Color for text separators.",
		"Foreground color for preformatted text segments.",
		"Background color for preformatted text segments.",
		"Background color for block quotes in text.",
		"Border color for block quotes in text.",
		"Background color for code blocks in text.",
	],
	"vs/platform/theme/common/colors/chartsColors": [
		"The foreground color used in charts.",
		"The color used for horizontal lines in charts.",
		"The red color used in chart visualizations.",
		"The blue color used in chart visualizations.",
		"The yellow color used in chart visualizations.",
		"The orange color used in chart visualizations.",
		"The green color used in chart visualizations.",
		"The purple color used in chart visualizations.",
	],
	"vs/platform/theme/common/colors/editorColors": [
		"Editor background color.",
		"Editor default foreground color.",
		"Background color of sticky scroll in the editor",
		"Background color of sticky scroll on hover in the editor",
		"Border color of sticky scroll in the editor",
		" Shadow color of sticky scroll in the editor",
		"Background color of editor widgets, such as find/replace.",
		"Foreground color of editor widgets, such as find/replace.",
		"Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget.",
		"Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget.",
		"Background color of error text in the editor. The color must not be opaque so as not to hide underlying decorations.",
		"Foreground color of error squigglies in the editor.",
		"If set, color of double underlines for errors in the editor.",
		"Background color of warning text in the editor. The color must not be opaque so as not to hide underlying decorations.",
		"Foreground color of warning squigglies in the editor.",
		"If set, color of double underlines for warnings in the editor.",
		"Background color of info text in the editor. The color must not be opaque so as not to hide underlying decorations.",
		"Foreground color of info squigglies in the editor.",
		"If set, color of double underlines for infos in the editor.",
		"Foreground color of hint squigglies in the editor.",
		"If set, color of double underlines for hints in the editor.",
		"Color of active links.",
		"Color of the editor selection.",
		"Color of the selected text for high contrast.",
		"Color of the selection in an inactive editor. The color must not be opaque so as not to hide underlying decorations.",
		"Color for regions with the same content as the selection. The color must not be opaque so as not to hide underlying decorations.",
		"Border color for regions with the same content as the selection.",
		"Color of the current search match.",
		"Color of the other search matches. The color must not be opaque so as not to hide underlying decorations.",
		"Color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations.",
		"Border color of the current search match.",
		"Border color of the other search matches.",
		"Border color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations.",
		"Highlight below the word for which a hover is shown. The color must not be opaque so as not to hide underlying decorations.",
		"Background color of the editor hover.",
		"Foreground color of the editor hover.",
		"Border color of the editor hover.",
		"Background color of the editor hover status bar.",
		"Foreground color of inline hints",
		"Background color of inline hints",
		"Foreground color of inline hints for types",
		"Background color of inline hints for types",
		"Foreground color of inline hints for parameters",
		"Background color of inline hints for parameters",
		"The color used for the lightbulb actions icon.",
		"The color used for the lightbulb auto fix actions icon.",
		"The color used for the lightbulb AI icon.",
		"Highlight background color of a snippet tabstop.",
		"Highlight border color of a snippet tabstop.",
		"Highlight background color of the final tabstop of a snippet.",
		"Highlight border color of the final tabstop of a snippet.",
		"Background color for text that got inserted. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for text that got removed. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for lines that got inserted. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for lines that got removed. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for the margin where lines got inserted.",
		"Background color for the margin where lines got removed.",
		"Diff overview ruler foreground for inserted content.",
		"Diff overview ruler foreground for removed content.",
		"Outline color for the text that got inserted.",
		"Outline color for text that got removed.",
		"Border color between the two text editors.",
		"Color of the diff editor\'s diagonal fill. The diagonal fill is used in side-by-side diff views.",
		"The background color of unchanged blocks in the diff editor.",
		"The foreground color of unchanged blocks in the diff editor.",
		"The background color of unchanged code in the diff editor.",
		"Shadow color of widgets such as find/replace inside the editor.",
		"Border color of widgets such as find/replace inside the editor.",
		"Toolbar background when hovering over actions using the mouse",
		"Toolbar outline when hovering over actions using the mouse",
		"Toolbar background when holding the mouse over actions",
		"Color of focused breadcrumb items.",
		"Background color of breadcrumb items.",
		"Color of focused breadcrumb items.",
		"Color of selected breadcrumb items.",
		"Background color of breadcrumb item picker.",
		"Current header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Current content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Incoming header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Incoming content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Common ancestor header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Common ancestor content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Border color on headers and the splitter in inline merge-conflicts.",
		"Current overview ruler foreground for inline merge-conflicts.",
		"Incoming overview ruler foreground for inline merge-conflicts.",
		"Common ancestor overview ruler foreground for inline merge-conflicts.",
		"Overview ruler marker color for find matches. The color must not be opaque so as not to hide underlying decorations.",
		"Overview ruler marker color for selection highlights. The color must not be opaque so as not to hide underlying decorations.",
		"The color used for the problems error icon.",
		"The color used for the problems warning icon.",
		"The color used for the problems info icon.",
	],
	"vs/platform/theme/common/colors/inputColors": [
		"Input box background.",
		"Input box foreground.",
		"Input box border.",
		"Border color of activated options in input fields.",
		"Background color of activated options in input fields.",
		"Background hover color of options in input fields.",
		"Foreground color of activated options in input fields.",
		"Input box foreground color for placeholder text.",
		"Input validation background color for information severity.",
		"Input validation foreground color for information severity.",
		"Input validation border color for information severity.",
		"Input validation background color for warning severity.",
		"Input validation foreground color for warning severity.",
		"Input validation border color for warning severity.",
		"Input validation background color for error severity.",
		"Input validation foreground color for error severity.",
		"Input validation border color for error severity.",
		"Dropdown background.",
		"Dropdown list background.",
		"Dropdown foreground.",
		"Dropdown border.",
		"Button foreground color.",
		"Button separator color.",
		"Button background color.",
		"Button background color when hovering.",
		"Button border color.",
		"Secondary button foreground color.",
		"Secondary button background color.",
		"Secondary button background color when hovering.",
		"Background color of checkbox widget.",
		"Background color of checkbox widget when the element it\'s in is selected.",
		"Foreground color of checkbox widget.",
		"Border color of checkbox widget.",
		"Border color of checkbox widget when the element it\'s in is selected.",
		"Keybinding label background color. The keybinding label is used to represent a keyboard shortcut.",
		"Keybinding label foreground color. The keybinding label is used to represent a keyboard shortcut.",
		"Keybinding label border color. The keybinding label is used to represent a keyboard shortcut.",
		"Keybinding label border bottom color. The keybinding label is used to represent a keyboard shortcut.",
	],
	"vs/platform/theme/common/colors/listColors": [
		"List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree outline color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree outline color for the focused item when the list/tree is active and selected. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree icon foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree icon foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree outline color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background when hovering over items using the mouse.",
		"List/Tree foreground when hovering over items using the mouse.",
		"List/Tree drag and drop background when moving items over other items when using the mouse.",
		"List/Tree drag and drop border color when moving items between items when using the mouse.",
		"List/Tree foreground color of the match highlights when searching inside the list/tree.",
		"List/Tree foreground color of the match highlights on actively focused items when searching inside the list/tree.",
		"List/Tree foreground color for invalid items, for example an unresolved root in explorer.",
		"Foreground color of list items containing errors.",
		"Foreground color of list items containing warnings.",
		"Background color of the type filter widget in lists and trees.",
		"Outline color of the type filter widget in lists and trees.",
		"Outline color of the type filter widget in lists and trees, when there are no matches.",
		"Shadow color of the type filter widget in lists and trees.",
		"Background color of the filtered match.",
		"Border color of the filtered match.",
		"List/Tree foreground color for items that are deemphasized.",
		"Tree stroke color for the indentation guides.",
		"Tree stroke color for the indentation guides that are not active.",
		"Table border color between columns.",
		"Background color for odd table rows.",
	],
	"vs/platform/theme/common/colors/menuColors": [
		"Border color of menus.",
		"Foreground color of menu items.",
		"Background color of menu items.",
		"Foreground color of the selected menu item in menus.",
		"Background color of the selected menu item in menus.",
		"Border color of the selected menu item in menus.",
		"Color of a separator menu item in menus.",
	],
	"vs/platform/theme/common/colors/minimapColors": [
		"Minimap marker color for find matches.",
		"Minimap marker color for repeating editor selections.",
		"Minimap marker color for the editor selection.",
		"Minimap marker color for infos.",
		"Minimap marker color for warnings.",
		"Minimap marker color for errors.",
		"Minimap background color.",
		"Opacity of foreground elements rendered in the minimap. For example, \"#000000c0\" will render the elements with 75% opacity.",
		"Minimap slider background color.",
		"Minimap slider background color when hovering.",
		"Minimap slider background color when clicked on.",
	],
	"vs/platform/theme/common/colors/miscColors": [
		"Border color of active sashes.",
		"Badge background color. Badges are small information labels, e.g. for search results count.",
		"Badge foreground color. Badges are small information labels, e.g. for search results count.",
		"Scrollbar shadow to indicate that the view is scrolled.",
		"Scrollbar slider background color.",
		"Scrollbar slider background color when hovering.",
		"Scrollbar slider background color when clicked on.",
		"Background color of the progress bar that can show for long running operations.",
	],
	"vs/platform/theme/common/colors/quickpickColors": [
		"Quick picker background color. The quick picker widget is the container for pickers like the command palette.",
		"Quick picker foreground color. The quick picker widget is the container for pickers like the command palette.",
		"Quick picker title background color. The quick picker widget is the container for pickers like the command palette.",
		"Quick picker color for grouping labels.",
		"Quick picker color for grouping borders.",
		"Please use quickInputList.focusBackground instead",
		"Quick picker foreground color for the focused item.",
		"Quick picker icon foreground color for the focused item.",
		"Quick picker background color for the focused item.",
	],
	"vs/platform/theme/common/colors/searchColors": [
		"Color of the text in the search viewlet\'s completion message.",
		"Color of the Search Editor query matches.",
		"Border color of the Search Editor query matches.",
	],
	"vs/platform/theme/common/iconRegistry": [
		"Die ID der zu verwendenden Schriftart. Sofern nicht festgelegt, wird die zuerst definierte Schriftart verwendet.",
		"Das der Symboldefinition zugeordnete Schriftzeichen.",
		"Symbol für Aktion zum Schließen in Widgets",
		"Symbol für den Wechsel zur vorherigen Editor-Position.",
		"Symbol für den Wechsel zur nächsten Editor-Position.",
	],
	"vs/platform/undoRedo/common/undoRedoService": [
		"Die folgenden Dateien wurden geschlossen und auf dem Datenträger geändert: {0}.",
		"Die folgenden Dateien wurden auf inkompatible Weise geändert: {0}.",
		"\"{0}\" konnte nicht für alle Dateien rückgängig gemacht werden. {1}",
		"\"{0}\" konnte nicht für alle Dateien rückgängig gemacht werden. {1}",
		"\"{0}\" konnte nicht für alle Dateien rückgängig gemacht werden, da Änderungen an {1} vorgenommen wurden.",
		"\"{0}\" konnte nicht für alle Dateien rückgängig gemacht werden, weil bereits ein Vorgang zum Rückgängigmachen oder Wiederholen für \"{1}\" durchgeführt wird.",
		"\"{0}\" konnte nicht für alle Dateien rückgängig gemacht werden, weil in der Zwischenzeit bereits ein Vorgang zum Rückgängigmachen oder Wiederholen durchgeführt wurde.",
		"Möchten Sie \"{0}\" für alle Dateien rückgängig machen?",
		"&&In {0} Dateien rückgängig machen",
		"&&Datei rückgängig machen",
		"\"{0}\" konnte nicht rückgängig gemacht werden, weil bereits ein Vorgang zum Rückgängigmachen oder Wiederholen durchgeführt wird.",
		"Möchten Sie \"{0}\" rückgängig machen?",
		"&&Ja",
		"Nein",
		"\"{0}\" konnte nicht in allen Dateien wiederholt werden. {1}",
		"\"{0}\" konnte nicht in allen Dateien wiederholt werden. {1}",
		"\"{0}\" konnte nicht in allen Dateien wiederholt werden, da Änderungen an {1} vorgenommen wurden.",
		"\"{0}\" konnte nicht für alle Dateien wiederholt werden, weil bereits ein Vorgang zum Rückgängigmachen oder Wiederholen für \"{1}\" durchgeführt wird.",
		"\"{0}\" konnte nicht für alle Dateien wiederholt werden, weil in der Zwischenzeit bereits ein Vorgang zum Rückgängigmachen oder Wiederholen durchgeführt wurde.",
		"\"{0}\" konnte nicht wiederholt werden, weil bereits ein Vorgang zum Rückgängigmachen oder Wiederholen durchgeführt wird.",
	],
	"vs/platform/workspace/common/workspace": [
		"Codearbeitsbereich",
	]
});